/* eslint-disable */
import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};

export type AddCaseformSessionByScheduleIdArgs = {
  clientName: Scalars['String'];
  id: Scalars['Float'];
  scheduleType: Scalars['String'];
};

export type AddCenterArgs = {
  altName?: InputMaybe<Scalars['String']>;
  applicationProcedure?: InputMaybe<Scalars['String']>;
  callerInfoAllowed?: InputMaybe<Scalars['Boolean']>;
  city: Scalars['String'];
  clientId: Scalars['Int'];
  clientName: Scalars['String'];
  county?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eligibility?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  faxNumber?: InputMaybe<Scalars['String']>;
  feeScale?: InputMaybe<Scalars['String']>;
  mailingAddress?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  referralsAllowed?: InputMaybe<Scalars['Boolean']>;
  serviceIds: Array<Scalars['Int']>;
  state: Scalars['String'];
  streetAddress: Scalars['String'];
  websiteAddress: Scalars['String'];
  websiteNotes?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type AddClientArgs = {
  companyName: Scalars['String'];
  name: Scalars['String'];
  primaryContactEmail: Scalars['String'];
  primaryContactName: Scalars['String'];
  primaryContactPhone: Scalars['String'];
};

export type AddLineOfBusinessArgs = {
  clientName: Scalars['String'];
  name: Scalars['String'];
  workflowType?: InputMaybe<Scalars['String']>;
};

export type AddOrUpdateClientRoleArgs = {
  clientName: Scalars['String'];
  name: Scalars['String'];
  privileges: Array<ClientRolePrivilegeArgs>;
  roleId?: InputMaybe<Scalars['Int']>;
};

export type AddPatientArgs = {
  assignedUserId: Scalars['Int'];
  clientName: Scalars['String'];
  currentProfileId?: InputMaybe<Scalars['Int']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  ipAddress: Scalars['String'];
  lastName: Scalars['String'];
  linkedProfileId?: InputMaybe<Scalars['Int']>;
  middleName: Scalars['String'];
  phone: Scalars['String'];
};

export type AddPatientOutreachReasonArgs = {
  clientName: Scalars['String'];
  compliance: Scalars['String'];
  patientId: Scalars['Int'];
  reasonForCall: Scalars['String'];
  session: Scalars['Int'];
};

export type AddPatientReassuranceStatusArgs = {
  clientName: Scalars['String'];
  endDate: Scalars['String'];
  enteredBy: Scalars['String'];
  note: Scalars['String'];
  patientId: Scalars['Int'];
  startDate: Scalars['String'];
  status: Scalars['String'];
};

export type AddPatientRelatedCallArgs = {
  agency: Scalars['String'];
  callDate: Scalars['String'];
  callType?: InputMaybe<Scalars['String']>;
  clientName: Scalars['String'];
  contact?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  patientId: Scalars['Int'];
  phone: Scalars['String'];
  requireFollowUp?: InputMaybe<Scalars['Boolean']>;
  scheduleId?: InputMaybe<Scalars['Int']>;
  session: Scalars['Int'];
  timeInOut: Scalars['String'];
  timeOff: Scalars['String'];
  timeOn: Scalars['String'];
  toFrom: Scalars['String'];
  worker: Scalars['String'];
};

export type AddPatientSessionArgs = {
  assignedUserId: Scalars['Int'];
  clientName: Scalars['String'];
  patientId: Scalars['Int'];
  session?: InputMaybe<Scalars['Int']>;
};

export type AddProfileArgs = {
  clientName: Scalars['String'];
  currentPatientId?: InputMaybe<Scalars['Int']>;
  hasGuidelines?: InputMaybe<Scalars['Boolean']>;
  hasSafetyPlan?: InputMaybe<Scalars['Boolean']>;
  isAttemptSurvivor?: InputMaybe<Scalars['Boolean']>;
  isHighRisk?: InputMaybe<Scalars['Boolean']>;
  isHomicidal?: InputMaybe<Scalars['Boolean']>;
  isSwatting?: InputMaybe<Scalars['Boolean']>;
  linkedProfileId?: InputMaybe<Scalars['Int']>;
  originPatientId: Scalars['Int'];
  reviewRequired?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
};

export type AddQuicklinkArgs = {
  clientName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdById: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedById: Scalars['Float'];
  url: Scalars['String'];
};

export type AddScheduleArgs = {
  allDay: Scalars['Boolean'];
  allowIdentifyOurself?: InputMaybe<Scalars['Boolean']>;
  allowVoicemailMessagesLeft?: InputMaybe<Scalars['Boolean']>;
  clientName: Scalars['String'];
  consentToBeContacted?: InputMaybe<Scalars['Boolean']>;
  createdBy: Scalars['String'];
  dateEnd?: InputMaybe<Scalars['String']>;
  dateStart: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  linkedPatientId?: InputMaybe<Scalars['Int']>;
  linkedPatientSession?: InputMaybe<Scalars['Int']>;
  notifiedAt?: InputMaybe<Scalars['String']>;
  organizerEmail?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['Float']>;
  primaryAssignedUserId?: InputMaybe<Scalars['Float']>;
  recurrence: Scalars['String'];
  scheduleType: Scalars['String'];
  secondaryAssignedUserId?: InputMaybe<Scalars['Float']>;
  sendEmailNotification?: InputMaybe<Scalars['Boolean']>;
  session?: InputMaybe<Scalars['Float']>;
  title: Scalars['String'];
  updatedBy: Scalars['String'];
};

export type AddThreeCxLineConfigArgs = {
  clientName: Scalars['String'];
  createCaseformEnabled: Scalars['Boolean'];
  dn: Scalars['String'];
  lineOfBusinessId: Scalars['Int'];
};

export type AddUpdateClientFeatureArgs = {
  category?: InputMaybe<Scalars['String']>;
  clientName: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  keywordClass?: InputMaybe<Scalars['String']>;
  keywordId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  orderIdDesc?: InputMaybe<Scalars['Boolean']>;
};

export type AddUserArgs = {
  clientId: Scalars['Int'];
  clientName: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneExtensionNumber: Scalars['String'];
  phoneName: Scalars['String'];
  selectedClientRoleId: Scalars['Float'];
  selectedRole?: InputMaybe<Roles>;
  workerNumber: Scalars['String'];
};

export type ArchiveUserArgs = {
  clientName: Scalars['String'];
  userId: Scalars['Int'];
};

export type AssignClientRoleArgs = {
  clientName: Scalars['String'];
  roleId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type AuthenticateUserArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type CallCountAndPctIncrease = {
  __typename?: 'CallCountAndPctIncrease';
  callCountToday: Scalars['Int'];
  percentIncrease: Scalars['Int'];
};

export type CallCounts = {
  __typename?: 'CallCounts';
  callCount: Scalars['Int'];
  date: Scalars['String'];
};

export type CallCountsByTime = {
  __typename?: 'CallCountsByTime';
  callCount: Scalars['Int'];
  time: Scalars['String'];
};

export type CaseFormAdvanceFilterArgs = {
  archiveStatus?: InputMaybe<Scalars['Float']>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  isSessionList?: InputMaybe<Scalars['Boolean']>;
  patientGroupRowsByPatientId?: InputMaybe<Scalars['Float']>;
  patientId?: InputMaybe<Scalars['Float']>;
  phone?: InputMaybe<Scalars['String']>;
  qualityPercent?: InputMaybe<Scalars['Float']>;
  qualityPercentComparator?: InputMaybe<Scalars['String']>;
  questions?: InputMaybe<Array<CaseFormAdvanceFilterQuestionsArgs>>;
  session?: InputMaybe<Scalars['Float']>;
  timeFrom?: InputMaybe<Scalars['String']>;
  timeTo?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  workerName?: InputMaybe<Scalars['String']>;
};

export type CaseFormAdvanceFilterQuestionsArgs = {
  id: Scalars['Float'];
  keyword: Scalars['String'];
};

export type Center = {
  __typename?: 'Center';
  address: Scalars['String'];
  altName?: Maybe<Scalars['String']>;
  applicationProcedure?: Maybe<Scalars['String']>;
  callerInfoAllowed: Scalars['Boolean'];
  city: Scalars['String'];
  clientId: Scalars['Int'];
  county?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  eligibility?: Maybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  faxNumber?: Maybe<Scalars['String']>;
  feeScale?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  mailingAddress?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  referralsAllowed: Scalars['Boolean'];
  services: Array<Service>;
  state: Scalars['String'];
  streetAddress: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  websiteAddress: Scalars['String'];
  websiteNotes?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CenterInfo = {
  __typename?: 'CenterInfo';
  address: Scalars['String'];
  callerInfoAllowed: Scalars['Boolean'];
  clientId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  referralsAllowed: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  websiteAddress: Scalars['String'];
};

export type CenterPatientAvgTimeByDay = {
  __typename?: 'CenterPatientAvgTimeByDay';
  date: Scalars['String'];
  minutes: Scalars['Int'];
};

export type CenterReferralVerificationStatus = {
  __typename?: 'CenterReferralVerificationStatus';
  allowsCallerInfo: VerificationAspectStatus;
  allowsReferrals: VerificationAspectStatus;
  contactInfo: VerificationAspectStatus;
  resourceInfo: VerificationAspectStatus;
};

export type Client = {
  __typename?: 'Client';
  companyName: Scalars['String'];
  contactEmail?: Maybe<Scalars['String']>;
  contactPerson?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  number?: Maybe<Scalars['String']>;
};

export type Client3cxInfo = {
  __typename?: 'Client3cxInfo';
  lastRaws?: Maybe<Array<Scalars['String']>>;
  notifStatus?: Maybe<Scalars['String']>;
  tokenDuration?: Maybe<Scalars['Float']>;
  tokenRequestTime?: Maybe<Scalars['String']>;
};

export type ClientExport = {
  __typename?: 'ClientExport';
  buildFormat: Scalars['String'];
  format: Scalars['String'];
  id: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ClientFeaturesAccess = {
  __typename?: 'ClientFeaturesAccess';
  accesses: Array<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  feature: Scalars['String'];
  id: Scalars['Int'];
  isDefault?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  keywordClass?: Maybe<Scalars['String']>;
  keywordId?: Maybe<Scalars['Float']>;
  keywordName?: Maybe<Scalars['String']>;
};

/** Possible actions for Client Integrations */
export enum ClientIntegrationActions {
  Subscribe = 'SUBSCRIBE'
}

export type ClientIntegrations = {
  __typename?: 'ClientIntegrations';
  mitel?: Maybe<MitelIntegrationType>;
};

export type ClientPreference = {
  __typename?: 'ClientPreference';
  isMobileCrisisEnabled?: Maybe<Scalars['Boolean']>;
  isPrimaryTabsOnly?: Maybe<Scalars['Boolean']>;
  isSoslEnabled?: Maybe<Scalars['Boolean']>;
  lineCalledList?: Maybe<Array<Scalars['String']>>;
  state?: Maybe<Scalars['String']>;
  timeCycle?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
};

export type ClientPublic = {
  __typename?: 'ClientPublic';
  companyName: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type ClientQuestions = {
  __typename?: 'ClientQuestions';
  category: Scalars['String'];
  id: Scalars['Int'];
  isEnabled: Scalars['Boolean'];
  question: Scalars['String'];
  questionType: Scalars['String'];
};

export type ClientRole = {
  __typename?: 'ClientRole';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  isDefault?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  privileges?: Maybe<Array<UserRolePrivileges>>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['Float']>;
};

export type ClientRolePrivilegeArgs = {
  accesses: Array<Scalars['String']>;
  feature: Scalars['String'];
  id: Scalars['Int'];
};

export type CovidCountAndPctIncrease = {
  __typename?: 'CovidCountAndPctIncrease';
  covidCountToday: Scalars['Int'];
  percentIncrease: Scalars['Int'];
};

export type CovidCounts = {
  __typename?: 'CovidCounts';
  covidCount: Scalars['Int'];
  date: Scalars['String'];
};

export type CreateOrAddToExistingPatientGroupArgs = {
  clientName: Scalars['String'];
  patientIds: Array<Scalars['Int']>;
};

export type CreateOrUpdateReferralClaimByReferralIdArgs = {
  address?: InputMaybe<Scalars['String']>;
  clientName: Scalars['String'];
  coverages?: InputMaybe<Array<CreateUpdateResourceReferralClaimsCoverageArgs>>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['Int']>;
  resourceReferralId: Scalars['String'];
};

export type CreateOrUpdateResourceReferralByArgs = {
  clientName: Scalars['String'];
  confirmStatus: Scalars['String'];
  contactEmail?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isReminder?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  requestType: Scalars['String'];
  resourceId: Scalars['Int'];
  sendNow: Scalars['Boolean'];
  sendNowUpdate?: InputMaybe<Scalars['Boolean']>;
  sentByUserId?: InputMaybe<Scalars['Int']>;
  titleRole?: InputMaybe<Scalars['String']>;
};

export type CreatePartnerAppArgs = {
  allowedApiScopes?: InputMaybe<Array<Scalars['String']>>;
  allowedLineCalledKeywords: Array<Scalars['String']>;
  appName: Scalars['String'];
  appType: Scalars['String'];
  clientName: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
};

export type CreateReferralArgs = {
  centerId: Scalars['Int'];
  clientName: Scalars['String'];
  patientId: Scalars['Int'];
  sessionNumber?: InputMaybe<Scalars['Int']>;
};

export type CreateReferralsForCentersArgs = {
  centerIds: Array<Scalars['Int']>;
  clientName: Scalars['String'];
  requestType: Scalars['String'];
};

export type CreateSelfServiceReportTemplateArgs = {
  clientName: Scalars['String'];
  name: Scalars['String'];
  payload: Scalars['String'];
};

export type CreateUpdateResourceReferralClaimsCoverageArgs = {
  group?: InputMaybe<Scalars['String']>;
  iid?: InputMaybe<Scalars['String']>;
  levelCount: Scalars['Float'];
  name?: InputMaybe<Scalars['String']>;
};

export type CrisisDashboard = {
  __typename?: 'CrisisDashboard';
  ageGroupBreakdown: Array<CrisisDashboardBreakdownItem>;
  callVolumeByMonth: Array<CrisisDashboardCallVolumeByMonth>;
  countyBreakdown: Array<CrisisDashboardBreakdownItem>;
  dispatchBreakdown: Array<CrisisDashboardBreakdownItem>;
  endDateTime: Scalars['String'];
  ethnicityBreakdown: Array<CrisisDashboardBreakdownItem>;
  fosterCareBreakdown: Array<CrisisDashboardBreakdownItem>;
  genderBreakdown: Array<CrisisDashboardBreakdownItem>;
  raceBreakdown: Array<CrisisDashboardBreakdownItem>;
  startDateTime: Scalars['String'];
  stateBreakdown: Array<CrisisDashboardBreakdownItem>;
  summary: CrisisDashboardSummary;
};

export type CrisisDashboardBreakdownItem = {
  __typename?: 'CrisisDashboardBreakdownItem';
  count: Scalars['Int'];
  label: Scalars['String'];
  percent?: Maybe<Scalars['Float']>;
};

export type CrisisDashboardCallVolumeByMonth = {
  __typename?: 'CrisisDashboardCallVolumeByMonth';
  month: Scalars['String'];
  sessionCount: Scalars['Int'];
};

export type CrisisDashboardSummary = {
  __typename?: 'CrisisDashboardSummary';
  crisisCallCount: Scalars['Int'];
  dispatchRatePercent: Scalars['Float'];
  mobileDispatchCount: Scalars['Int'];
  resourcesGivenCount: Scalars['Int'];
  uniqueContactCount: Scalars['Int'];
};

export type CrisisDispositionReferenceEntry = {
  __typename?: 'CrisisDispositionReferenceEntry';
  configured: Scalars['Boolean'];
  questionId?: Maybe<Scalars['Int']>;
  questionKey: Scalars['String'];
};

export type CrisisMetricDictionaryEntry = {
  __typename?: 'CrisisMetricDictionaryEntry';
  category: Scalars['String'];
  description: Scalars['String'];
  metric: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  questionKeys: Array<Scalars['String']>;
  questions: Array<CrisisMetricQuestionRef>;
  source: Scalars['String'];
};

export type CrisisMetricQuestionRef = {
  __typename?: 'CrisisMetricQuestionRef';
  configured: Scalars['Boolean'];
  questionId?: Maybe<Scalars['Int']>;
  questionKey: Scalars['String'];
};

export type CrisisMetricsDictionary = {
  __typename?: 'CrisisMetricsDictionary';
  clientName: Scalars['String'];
  dispositionReferences: Array<CrisisDispositionReferenceEntry>;
  introNote: Scalars['String'];
  metrics: Array<CrisisMetricDictionaryEntry>;
  missingQuestionKeys?: Maybe<Array<Scalars['String']>>;
  version: Scalars['String'];
};

export type DailyOpsCallVolumeByDay = {
  __typename?: 'DailyOpsCallVolumeByDay';
  date: Scalars['String'];
  sessionCount: Scalars['Int'];
};

export type DailyOpsCallerSessionCount = {
  __typename?: 'DailyOpsCallerSessionCount';
  contactName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  inRangeSessionCount?: Maybe<Scalars['Int']>;
  ipAddress?: Maybe<Scalars['String']>;
  patientId: Scalars['Int'];
  phone?: Maybe<Scalars['String']>;
  sessionCount: Scalars['Int'];
};

export type DailyOpsDashboard = {
  __typename?: 'DailyOpsDashboard';
  callVolume: Scalars['Int'];
  callVolumeByDay?: Maybe<Array<DailyOpsCallVolumeByDay>>;
  callVolumeByLine?: Maybe<Array<DailyOpsVolumeByLine>>;
  callVolumeByWorker?: Maybe<Array<DailyOpsVolumeByWorker>>;
  callerSessionCounts?: Maybe<Array<DailyOpsCallerSessionCount>>;
  familiarCallerSessionCounts?: Maybe<Array<DailyOpsCallerSessionCount>>;
  finishedCaseformsCount?: Maybe<Scalars['Int']>;
  primaryIssueBreakdown?: Maybe<Array<DailyOpsIssueBreakdown>>;
  secondaryIssueBreakdown?: Maybe<Array<DailyOpsIssueBreakdown>>;
  sessions: Array<PatientCaseFormSession>;
  staffOnShift: Array<DailyOpsStaffMember>;
  totalSessionCount: Scalars['Int'];
  unfinishedCaseformsCount?: Maybe<Scalars['Int']>;
};

export type DailyOpsIssueBreakdown = {
  __typename?: 'DailyOpsIssueBreakdown';
  issue: Scalars['String'];
  sessionCount: Scalars['Int'];
};

export type DailyOpsStaffMember = {
  __typename?: 'DailyOpsStaffMember';
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
};

export type DailyOpsVolumeByLine = {
  __typename?: 'DailyOpsVolumeByLine';
  lineCalled?: Maybe<Scalars['String']>;
  sessionCount: Scalars['Int'];
};

export type DailyOpsVolumeByWorker = {
  __typename?: 'DailyOpsVolumeByWorker';
  assignedUserId: Scalars['Int'];
  assignedUserName?: Maybe<Scalars['String']>;
  sessionCount: Scalars['Int'];
};

export type DeleteCenterByIdArgs = {
  centerId: Scalars['Int'];
  clientId: Scalars['Int'];
};

export type DeleteClientArgs = {
  companyName: Scalars['String'];
  id: Scalars['Int'];
};

export type DeleteClientFeatureArgs = {
  clientName: Scalars['String'];
  id: Scalars['Int'];
};

export type DeleteClientRoleArgs = {
  clientName: Scalars['String'];
  roleId: Scalars['Int'];
};

export type DeleteLineOfBusinessArgs = {
  clientName: Scalars['String'];
  id: Scalars['Int'];
};

export type DeleteOrArchiveUserArgs = {
  clientName: Scalars['String'];
  userId: Scalars['Int'];
};

export type DeletePatientArgs = {
  clientName: Scalars['String'];
  patientId: Scalars['Int'];
};

export type DeletePatientOutreachReasonArgs = {
  clientName: Scalars['String'];
  id: Scalars['Int'];
};

export type DeletePatientReassuranceStatusArgs = {
  clientName: Scalars['String'];
  patientId: Scalars['Int'];
  reassuranceStatusId: Scalars['Int'];
};

export type DeletePatientRelatedCallArgs = {
  clientName: Scalars['String'];
  id: Scalars['Int'];
};

export type DeleteQuicklinkByIdArgs = {
  clientName: Scalars['String'];
  id: Scalars['Float'];
};

export type DeleteScheduleArgs = {
  clientName: Scalars['String'];
  id: Scalars['Float'];
  organizerEmail?: InputMaybe<Scalars['String']>;
  sendEmailNotification?: InputMaybe<Scalars['Boolean']>;
};

export type DeleteSelfServiceReportTemplateArgs = {
  clientName: Scalars['String'];
  id: Scalars['Int'];
};

export type DeleteThreeCxLineConfigArgs = {
  clientName: Scalars['String'];
  dn: Scalars['String'];
};

export type DeleteTokenArgs = {
  token: Scalars['String'];
};

export type DoClientIntegrationsArgs = {
  clientName: Scalars['String'];
  integrationAction: ClientIntegrationActions;
  integrationName: Scalars['String'];
};

export type EditUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneExtensionNumber?: InputMaybe<Scalars['String']>;
  phoneName?: InputMaybe<Scalars['String']>;
  selectedRole: Roles;
  userId: Scalars['Int'];
  workerNumber?: InputMaybe<Scalars['String']>;
};

export type ExportClientRelatedCallsArgs = {
  clientName: Scalars['String'];
};

export type ExportClientResourcesArgs = {
  clientName: Scalars['String'];
};

export type ForgotPasswordArgs = {
  email: Scalars['String'];
};

export type GenerateResourceReportsBundleArgs = {
  age?: InputMaybe<Array<Scalars['String']>>;
  ageGroup?: InputMaybe<Array<Scalars['String']>>;
  appliedTemplateName?: InputMaybe<Scalars['String']>;
  archivedFilter?: InputMaybe<SelfServiceSessionArchivedFilter>;
  callType?: InputMaybe<Array<Scalars['String']>>;
  clientName: Scalars['String'];
  county?: InputMaybe<Array<Scalars['String']>>;
  endDate: Scalars['String'];
  exportQuestionIds?: InputMaybe<Array<Scalars['Int']>>;
  gender?: InputMaybe<Array<Scalars['String']>>;
  imminentRiskSuicidal?: InputMaybe<Array<Scalars['String']>>;
  includeRelatedCalls?: InputMaybe<Scalars['Boolean']>;
  includeResources?: InputMaybe<Scalars['Boolean']>;
  lineCalled?: InputMaybe<Array<Scalars['String']>>;
  sessionUniqueIds?: InputMaybe<Array<Scalars['String']>>;
  splitByMonth?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['String'];
  state?: InputMaybe<Array<Scalars['String']>>;
  textSearch?: InputMaybe<Scalars['String']>;
};

export type GetAllAnswersByQuestionIdArgs = {
  clientName: Scalars['String'];
  questionId: Scalars['Float'];
};

export type GetAllCaseFormArgs = {
  advanceFilter?: InputMaybe<CaseFormAdvanceFilterArgs>;
  assignedUserId?: InputMaybe<Scalars['Float']>;
  clientName: Scalars['String'];
  filter24hours: Scalars['Boolean'];
  filterGroupId?: InputMaybe<Scalars['Float']>;
  filterMyCaseform: Scalars['Boolean'];
  group?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Float'];
  offset: Scalars['Float'];
  textSearch?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type GetAllCaseFormSessionsArgs = {
  advanceFilter?: InputMaybe<CaseFormAdvanceFilterArgs>;
  assignedUserId?: InputMaybe<Scalars['Float']>;
  clientName: Scalars['String'];
  filter24hours: Scalars['Boolean'];
  filterGroupId?: InputMaybe<Scalars['Float']>;
  filterMyCaseform: Scalars['Boolean'];
  group?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Float'];
  offset: Scalars['Float'];
  textSearch?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type GetAllCenterByServicesArgs = {
  clientName: Scalars['String'];
  servicesIds: Array<Scalars['Int']>;
};

export type GetAllCentersArgs = {
  clientName: Scalars['String'];
  keyword?: InputMaybe<Scalars['String']>;
  keywordAddress?: InputMaybe<Scalars['String']>;
};

export type GetAllPatientsQuestionAnswerArgs = {
  assignedUserId: Scalars['Float'];
  clientName: Scalars['String'];
  maxRowPerFile?: InputMaybe<Scalars['Float']>;
};

export type GetAllPatientsQuestionAnswerDataArgs = {
  clientName: Scalars['String'];
  limit: Scalars['Float'];
  offset: Scalars['Float'];
};

export type GetAllUsersArgs = {
  clientId: Scalars['Int'];
};

export type GetAllUsersByClientNameArgs = {
  clientName: Scalars['String'];
};

export type GetCaseformQualityPercentArgs = {
  clientName: Scalars['String'];
  patientId: Scalars['Int'];
  session: Scalars['Int'];
};

export type GetCaseformQualityPercentByPatientsArgs = {
  clientName: Scalars['String'];
  patients: Array<QualityPercentPatientsArgs>;
};

export type GetCaseformSessionsWithPatientsAndQuestionsArgs = {
  clientName: Scalars['String'];
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type GetCenterArgs = {
  centerId: Scalars['Int'];
  clientName: Scalars['String'];
};

export type GetCenterReferralVerificationStatusArgs = {
  centerId: Scalars['Int'];
  clientName: Scalars['String'];
};

export type GetCentersInfoByPatientIdArgs = {
  clientName: Scalars['String'];
  patientId: Scalars['Int'];
};

export type GetClientAnalyticsArgs = {
  ageRange?: InputMaybe<Scalars['String']>;
  clientName: Scalars['String'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type GetClientDetailsArgs = {
  clientId: Scalars['Int'];
};

export type GetClientFeaturesAccessArgs = {
  byFeatureIds?: InputMaybe<Array<Scalars['Int']>>;
  byFeatures?: InputMaybe<Array<Scalars['String']>>;
  clientName: Scalars['String'];
  orderIdDesc?: InputMaybe<Scalars['Boolean']>;
  withKeywordClassName?: InputMaybe<Scalars['Boolean']>;
};

export type GetClientPreferenceArgs = {
  clientName: Scalars['String'];
  getCache?: InputMaybe<Scalars['Boolean']>;
  isPrimaryTabsOnly?: InputMaybe<Scalars['Boolean']>;
  isSoslEnabled?: InputMaybe<Scalars['Boolean']>;
  lineCalledList?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['Boolean']>;
  timeCycle?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type GetClientQuestionsArgs = {
  clientName: Scalars['String'];
};

export type GetClientQuestionsByCategoryArgs = {
  category: Scalars['String'];
  clientName: Scalars['String'];
};

export type GetClientRolePrivilegesArgs = {
  clientName: Scalars['String'];
  roleId: Scalars['Int'];
};

export type GetClientRolesArgs = {
  clientName: Scalars['String'];
  roleId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
  willGetPrivileges?: InputMaybe<Scalars['Boolean']>;
};

export type GetClientRolesByUserIdsArgs = {
  clientName: Scalars['String'];
  userIds: Array<Scalars['Int']>;
};

export type GetCrisisDashboardArgs = {
  clientName: Scalars['String'];
  endDateTime: Scalars['String'];
  startDateTime: Scalars['String'];
  timezone?: InputMaybe<Scalars['String']>;
};

export type GetCurrentUserClientRolesArgs = {
  clientName: Scalars['String'];
};

export type GetDailyOpsDashboardArgs = {
  clientName: Scalars['String'];
  endDateTime: Scalars['String'];
  limit: Scalars['Int'];
  lineOfBusinessIds?: InputMaybe<Array<Scalars['Int']>>;
  minCallerSessionCount?: InputMaybe<Scalars['Int']>;
  offset: Scalars['Int'];
  startDateTime: Scalars['String'];
  timezone: Scalars['String'];
};

export type GetExportArgs = {
  class?: InputMaybe<Scalars['String']>;
  clientName: Scalars['String'];
  id?: InputMaybe<Scalars['Float']>;
};

export type GetExportBuildPatientQuestionsMapArgs = {
  clientName: Scalars['String'];
  keywordClass: Scalars['String'];
  keywordId: Scalars['Int'];
  patientId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type GetLinkedProfilesByIdArgs = {
  clientName: Scalars['String'];
  profileId: Scalars['Int'];
};

export type GetNotificationsByIdArgs = {
  clientName: Scalars['String'];
};

export type GetPatientCenterArgs = {
  clientName: Scalars['String'];
  patientId: Scalars['Int'];
  session: Scalars['Int'];
};

export type GetPatientInfoArgs = {
  clientName: Scalars['String'];
  email: Scalars['String'];
  ipAddress: Scalars['String'];
  phone: Scalars['String'];
};

export type GetPatientInfoByIdArgs = {
  clientName: Scalars['String'];
  patientId: Scalars['Int'];
};

export type GetPatientOutreachReasonArgs = {
  clientName: Scalars['String'];
  patientId: Scalars['Int'];
  session: Scalars['Int'];
};

export type GetPatientQuestionAnswerArgs = {
  clientName: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  patientId: Scalars['Int'];
  session?: InputMaybe<Scalars['Int']>;
};

export type GetPatientReassuranceStatusArgs = {
  clientName: Scalars['String'];
  patientId: Scalars['Int'];
};

export type GetPatientRelatedCallsArgs = {
  clientName: Scalars['String'];
  patientId: Scalars['Int'];
  session: Scalars['Int'];
};

export type GetPatientSessionsByArgs = {
  byPatientGroupId?: InputMaybe<Scalars['Int']>;
  byPatientId?: InputMaybe<Scalars['Int']>;
  clientName: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  sessionNumber?: InputMaybe<Scalars['Int']>;
};

export type GetPatientSessionsByPatientIdArgs = {
  clientName: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  patientId: Scalars['Int'];
  sessionNumber?: InputMaybe<Scalars['Int']>;
};

export type GetPatientsByClientIdArgs = {
  clientId: Scalars['Int'];
};

export type GetProfileByIdArgs = {
  clientName: Scalars['String'];
  id: Scalars['Int'];
};

export type GetProfileByPatientIdArgs = {
  clientName: Scalars['String'];
  includeLinkedProfiles?: InputMaybe<Scalars['Boolean']>;
  patientId: Scalars['Int'];
  source?: InputMaybe<Scalars['String']>;
};

export type GetProfileTimelineArgs = {
  activityType?: InputMaybe<Scalars['String']>;
  clientName: Scalars['String'];
  endDate?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  profileId: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type GetProfilesArgs = {
  clientName: Scalars['String'];
  hasGuidelines?: InputMaybe<Scalars['Boolean']>;
  hasSafetyPlan?: InputMaybe<Scalars['Boolean']>;
  isAttemptSurvivor?: InputMaybe<Scalars['Boolean']>;
  isHighRisk?: InputMaybe<Scalars['Boolean']>;
  isHomicidal?: InputMaybe<Scalars['Boolean']>;
  isSwatting?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patientId?: InputMaybe<Scalars['Int']>;
  reviewRequired?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type GetQuicklinkByIdArgs = {
  clientName: Scalars['String'];
  id: Scalars['Float'];
};

export type GetQuicklinksArgs = {
  clientName: Scalars['String'];
  itemPerPage?: InputMaybe<Scalars['Float']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Float']>;
};

export type GetReferralClaimsByReferralResourceIdArgs = {
  clientName: Scalars['String'];
  resourceReferralClaimId?: InputMaybe<Scalars['Int']>;
  resourceReferralId?: InputMaybe<Scalars['String']>;
};

export type GetReferralForVerificationArgs = {
  clientName: Scalars['String'];
  id: Scalars['String'];
};

export type GetResourceAnalyticsArgs = {
  clientName: Scalars['String'];
  endDateTime: Scalars['String'];
  lineOfBusinessIds?: InputMaybe<Array<Scalars['Int']>>;
  startDateTime: Scalars['String'];
  timezone: Scalars['String'];
};

export type GetResourceCatalogDashboardArgs = {
  cities?: InputMaybe<Array<Scalars['String']>>;
  clientName: Scalars['String'];
  counties?: InputMaybe<Array<Scalars['String']>>;
  eligibilityContains?: InputMaybe<Scalars['String']>;
  serviceIds?: InputMaybe<Array<Scalars['Int']>>;
  states?: InputMaybe<Array<Scalars['String']>>;
};

export type GetResourceCatalogFilterOptionsArgs = {
  clientName: Scalars['String'];
};

export type GetResourceReferralsArgs = {
  clientName: Scalars['String'];
  resourceId?: InputMaybe<Scalars['Float']>;
  resourceReferralId?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  withUserInfo?: InputMaybe<Scalars['Boolean']>;
};

export type GetScheduleArgs = {
  clientName: Scalars['String'];
  filter?: InputMaybe<GetScheduleFilter>;
};

export type GetScheduleByIdArgs = {
  clientName: Scalars['String'];
  id: Scalars['Float'];
};

export type GetScheduleByPatientArgs = {
  clientName: Scalars['String'];
  patientId: Scalars['Float'];
  scheduleType: Scalars['String'];
  session: Scalars['Float'];
};

export type GetScheduleByRelatedCallArgs = {
  clientName: Scalars['String'];
  relatedCallId: Scalars['Float'];
  session: Scalars['Float'];
};

export type GetScheduleFilter = {
  assignedUsedId?: InputMaybe<Scalars['Float']>;
  day?: InputMaybe<Scalars['Float']>;
  month?: InputMaybe<Scalars['Float']>;
  year?: InputMaybe<Scalars['Float']>;
};

export type GetSelfServiceReportExportHistoryArgs = {
  clientName: Scalars['String'];
  generatedAfter?: InputMaybe<Scalars['String']>;
  generatedBefore?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type GetSessionsForReportsArgs = {
  age?: InputMaybe<Array<Scalars['String']>>;
  ageGroup?: InputMaybe<Array<Scalars['String']>>;
  archivedFilter?: InputMaybe<SelfServiceSessionArchivedFilter>;
  callType?: InputMaybe<Array<Scalars['String']>>;
  clientName: Scalars['String'];
  county?: InputMaybe<Array<Scalars['String']>>;
  endDate?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Array<Scalars['String']>>;
  imminentRiskSuicidal?: InputMaybe<Array<Scalars['String']>>;
  limit: Scalars['Float'];
  lineCalled?: InputMaybe<Array<Scalars['String']>>;
  offset: Scalars['Float'];
  questionIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Array<Scalars['String']>>;
  textSearch?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
};

export type GetUserByIdArgs = {
  userId: Scalars['Int'];
};

export type GetUsersByIdsArgs = {
  userIds: Array<Scalars['Int']>;
};

export type LineOfBusiness = {
  __typename?: 'LineOfBusiness';
  displayOrder: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  workflowType: Scalars['String'];
};

export type LinkProfileArgs = {
  clientName: Scalars['String'];
  linkedProfileId: Scalars['Int'];
  profileId: Scalars['Int'];
};

export type MarkAsReadNotificationArgs = {
  clientName: Scalars['String'];
  timestamp?: InputMaybe<Scalars['String']>;
};

export type MitelIntegrationType = {
  __typename?: 'MitelIntegrationType';
  end?: Maybe<Scalars['String']>;
  lastNotificationDate?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export type MostUsedReassuranceCompliance = {
  __typename?: 'MostUsedReassuranceCompliance';
  compliance: Scalars['String'];
  useCount: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addCaseformSessionByScheduleId: PatientNewSessionSet;
  addCenter: Scalars['Boolean'];
  addClient: Scalars['Boolean'];
  addClientFeature: Scalars['String'];
  addClientRole: Scalars['String'];
  addLineOfBusiness: LineOfBusiness;
  addNotification: Scalars['Boolean'];
  addPatient: Patient;
  addPatientOutreachReason: Scalars['Boolean'];
  addPatientReassuranceStatus: Scalars['Boolean'];
  addPatientRelatedCall: Scalars['Boolean'];
  addPatientSession: Scalars['Boolean'];
  addPdfBuild: ClientExport;
  addProfile: Profile;
  addQuickLink: Scalars['Boolean'];
  addSchedule: Scalars['Float'];
  addThreeCxLineConfig: Scalars['Boolean'];
  addUser: Scalars['Boolean'];
  archiveUser: Scalars['Boolean'];
  assignClientRole: Scalars['Boolean'];
  authenticateUser: Scalars['String'];
  createOrAddToExistingPatientGroup: Scalars['Float'];
  createOrUpdateReferralByResourceId: ResourceReferral;
  createOrUpdateReferralClaimByReferralId: ResourceReferralClaim;
  createPartnerApp: PartnerAppCredentials;
  createReferral: ResourceReferral;
  createReferralsForCenters: Array<ResourceReferral>;
  createSelfServiceReportTemplate: SelfServiceReportTemplate;
  deleteCenterById: Scalars['Boolean'];
  deleteClient: Scalars['Boolean'];
  deleteClientFeature: Scalars['String'];
  deleteClientRole: Scalars['Boolean'];
  deleteDataFiles: Scalars['Boolean'];
  deleteLineOfBusiness: Scalars['Boolean'];
  deleteOrArchiveUser: Scalars['String'];
  deletePatient: Scalars['Boolean'];
  deletePatientOutreachReason: Scalars['Boolean'];
  deletePatientReassuranceStatus: Scalars['Boolean'];
  deletePatientRelatedCall: Scalars['Boolean'];
  deletePdfBuild: Scalars['Boolean'];
  deleteProfile: Scalars['Boolean'];
  deleteQuickLinkById: Scalars['Boolean'];
  deleteSchedule: Scalars['Boolean'];
  deleteSelfServiceReportTemplate: Scalars['Boolean'];
  deleteThreeCxLineConfig: Scalars['Boolean'];
  deleteToken: Scalars['Boolean'];
  doIntegrations: Scalars['Boolean'];
  editUser: Scalars['Boolean'];
  forgotPassword: Scalars['Boolean'];
  generateUserOtp: Scalars['String'];
  linkProfiles: Scalars['Boolean'];
  markAsReadNotification: Scalars['Boolean'];
  recordSelfServiceReportDownload: Scalars['Boolean'];
  refreshToken: Scalars['String'];
  removePatientFromPatientGroup: Scalars['Boolean'];
  requestReferralVerification: ResourceReferral;
  resetPassword: Scalars['Boolean'];
  resetUserOtp: Scalars['Boolean'];
  respondToReferralUpdate: ReferralVerificationResponse;
  respondToReferralVerification: ReferralVerificationResponse;
  revokePartnerApp: Scalars['Boolean'];
  rotatePartnerSecret: PartnerAppCredentials;
  setPatientQuestionAnswer: Scalars['String'];
  setThreeCxLineConfig: Scalars['Boolean'];
  toggleIsEnableClientQuestion: Scalars['Boolean'];
  toggleThreeCXNotifs: Scalars['Boolean'];
  unarchiveUser: Scalars['Boolean'];
  updateCenter: Scalars['Boolean'];
  updateClientDetails: Scalars['Boolean'];
  updateClientPreference: Scalars['Boolean'];
  updateClientRole: Scalars['String'];
  updateIsArchivedPatientSession: Scalars['Boolean'];
  updateLineOfBusiness: Scalars['Boolean'];
  updateNotesPatient: Scalars['Boolean'];
  updatePartnerApp: Scalars['Boolean'];
  updatePatient: Scalars['Boolean'];
  updatePatientCenter: Scalars['Boolean'];
  updatePatientOutreachReason: Scalars['Boolean'];
  updatePatientReassuranceStatus: Scalars['Boolean'];
  updatePatientRelatedCall: Scalars['Boolean'];
  updateProfile: Profile;
  updateQuickLinkById: Scalars['Boolean'];
  updateSchedule: Scalars['Boolean'];
  updateSelfServiceReportTemplate: SelfServiceReportTemplate;
  updateUserRole: Scalars['Boolean'];
  verifyUserOtp: Scalars['String'];
};


export type MutationAddCaseformSessionByScheduleIdArgs = {
  addCaseformSessionByScheduleIdArgs: AddCaseformSessionByScheduleIdArgs;
};


export type MutationAddCenterArgs = {
  addCenterArgs: AddCenterArgs;
};


export type MutationAddClientArgs = {
  addClientArgs: AddClientArgs;
};


export type MutationAddClientFeatureArgs = {
  addClientFeatureArgs: AddUpdateClientFeatureArgs;
};


export type MutationAddClientRoleArgs = {
  addOrUpdateClientRoleArgs: AddOrUpdateClientRoleArgs;
};


export type MutationAddLineOfBusinessArgs = {
  addLineOfBusinessArgs: AddLineOfBusinessArgs;
};


export type MutationAddNotificationArgs = {
  notificationPayloadArgs: NotificationPayloadArgs;
};


export type MutationAddPatientArgs = {
  addPatientArgs: AddPatientArgs;
};


export type MutationAddPatientOutreachReasonArgs = {
  addPatientOutreachReasonArgs: AddPatientOutreachReasonArgs;
};


export type MutationAddPatientReassuranceStatusArgs = {
  addPatientReassuranceStatusArgs: AddPatientReassuranceStatusArgs;
};


export type MutationAddPatientRelatedCallArgs = {
  addPatientRelatedCallArgs: AddPatientRelatedCallArgs;
};


export type MutationAddPatientSessionArgs = {
  addPatientSessionArgs: AddPatientSessionArgs;
};


export type MutationAddPdfBuildArgs = {
  pdfBuildArgs: PdfBuildArgs;
};


export type MutationAddProfileArgs = {
  addProfileArgs: AddProfileArgs;
};


export type MutationAddQuickLinkArgs = {
  addQuickLink: AddQuicklinkArgs;
};


export type MutationAddScheduleArgs = {
  addScheduleArgs: AddScheduleArgs;
};


export type MutationAddThreeCxLineConfigArgs = {
  addThreeCxLineConfigArgs: AddThreeCxLineConfigArgs;
};


export type MutationAddUserArgs = {
  addUserArgs: AddUserArgs;
};


export type MutationArchiveUserArgs = {
  archiveUserArgs: ArchiveUserArgs;
};


export type MutationAssignClientRoleArgs = {
  assignClientRoleArgs: AssignClientRoleArgs;
};


export type MutationAuthenticateUserArgs = {
  authenticateUserArgs: AuthenticateUserArgs;
};


export type MutationCreateOrAddToExistingPatientGroupArgs = {
  createOrAddToExistingPatientGroupArgs: CreateOrAddToExistingPatientGroupArgs;
};


export type MutationCreateOrUpdateReferralByResourceIdArgs = {
  createOrUpdateResourceReferralByArgs: CreateOrUpdateResourceReferralByArgs;
};


export type MutationCreateOrUpdateReferralClaimByReferralIdArgs = {
  createOrUpdateReferralClaimByReferralIdArgs: CreateOrUpdateReferralClaimByReferralIdArgs;
};


export type MutationCreatePartnerAppArgs = {
  createPartnerAppArgs: CreatePartnerAppArgs;
};


export type MutationCreateReferralArgs = {
  createReferralArgs: CreateReferralArgs;
};


export type MutationCreateReferralsForCentersArgs = {
  createReferralsForCentersArgs: CreateReferralsForCentersArgs;
};


export type MutationCreateSelfServiceReportTemplateArgs = {
  createSelfServiceReportTemplateArgs: CreateSelfServiceReportTemplateArgs;
};


export type MutationDeleteCenterByIdArgs = {
  deleteCenterByIdArgs: DeleteCenterByIdArgs;
};


export type MutationDeleteClientArgs = {
  deleteClientArgs: DeleteClientArgs;
};


export type MutationDeleteClientFeatureArgs = {
  deleteClientFeatureArgs: DeleteClientFeatureArgs;
};


export type MutationDeleteClientRoleArgs = {
  deleteClientRoleArgs: DeleteClientRoleArgs;
};


export type MutationDeleteDataFilesArgs = {
  awsS3DeleteFilesArgs: AwsS3DeleteFilesArgs;
};


export type MutationDeleteLineOfBusinessArgs = {
  deleteLineOfBusinessArgs: DeleteLineOfBusinessArgs;
};


export type MutationDeleteOrArchiveUserArgs = {
  deleteOrArchiveUserArgs: DeleteOrArchiveUserArgs;
};


export type MutationDeletePatientArgs = {
  deletePatientArgs: DeletePatientArgs;
};


export type MutationDeletePatientOutreachReasonArgs = {
  deletePatientOutreachReasonArgs: DeletePatientOutreachReasonArgs;
};


export type MutationDeletePatientReassuranceStatusArgs = {
  deletePatientReassuranceStatusArgs: DeletePatientReassuranceStatusArgs;
};


export type MutationDeletePatientRelatedCallArgs = {
  deletePatientRelatedCallArgs: DeletePatientRelatedCallArgs;
};


export type MutationDeletePdfBuildArgs = {
  pdfBuildArgs: PdfBuildArgs;
};


export type MutationDeleteProfileArgs = {
  clientName: Scalars['String'];
  id: Scalars['Float'];
};


export type MutationDeleteQuickLinkByIdArgs = {
  deleteQuickLinkById: DeleteQuicklinkByIdArgs;
};


export type MutationDeleteScheduleArgs = {
  deleteScheduleArgs: DeleteScheduleArgs;
};


export type MutationDeleteSelfServiceReportTemplateArgs = {
  args: DeleteSelfServiceReportTemplateArgs;
};


export type MutationDeleteThreeCxLineConfigArgs = {
  deleteThreeCxLineConfigArgs: DeleteThreeCxLineConfigArgs;
};


export type MutationDeleteTokenArgs = {
  deleteTokenArgs: DeleteTokenArgs;
};


export type MutationDoIntegrationsArgs = {
  doClientIntegrationsArgs: DoClientIntegrationsArgs;
};


export type MutationEditUserArgs = {
  editUserArgs: EditUserArgs;
};


export type MutationForgotPasswordArgs = {
  forgotPasswordArgs: ForgotPasswordArgs;
};


export type MutationLinkProfilesArgs = {
  linkProfileArgs: LinkProfileArgs;
};


export type MutationMarkAsReadNotificationArgs = {
  markAsReadNotificationArgs: MarkAsReadNotificationArgs;
};


export type MutationRecordSelfServiceReportDownloadArgs = {
  args: RecordSelfServiceReportDownloadArgs;
};


export type MutationRefreshTokenArgs = {
  refreshTokenArgs: RefreshTokenArgs;
};


export type MutationRemovePatientFromPatientGroupArgs = {
  removePatientFromPatientGroupArgs: RemovePatientFromPatientGroupArgs;
};


export type MutationRequestReferralVerificationArgs = {
  requestReferralVerificationArgs: RequestReferralVerificationArgs;
};


export type MutationResetPasswordArgs = {
  resetPasswordArgs: ResetPasswordArgs;
};


export type MutationResetUserOtpArgs = {
  resetUserOtpArgs: ResetOtpUserArgs;
};


export type MutationRespondToReferralUpdateArgs = {
  respondToReferralUpdateArgs: RespondToReferralUpdateArgs;
};


export type MutationRespondToReferralVerificationArgs = {
  respondToReferralVerificationArgs: RespondToReferralVerificationArgs;
};


export type MutationRevokePartnerAppArgs = {
  revokePartnerAppArgs: RevokePartnerAppArgs;
};


export type MutationRotatePartnerSecretArgs = {
  rotatePartnerSecretArgs: RotatePartnerSecretArgs;
};


export type MutationSetPatientQuestionAnswerArgs = {
  setPatientQuestionAnswerArgs: SetPatientQuestionAnswerArgs;
};


export type MutationSetThreeCxLineConfigArgs = {
  setThreeCxLineConfigArgs: SetThreeCxLineConfigArgs;
};


export type MutationToggleIsEnableClientQuestionArgs = {
  toggleIsEnableClientQuestionArgs: ToggleIsEnableClientQuestionArgs;
};


export type MutationToggleThreeCxNotifsArgs = {
  needsClientNameArgs: NeedsClientNameArgs;
};


export type MutationUnarchiveUserArgs = {
  unarchiveUserArgs: UnarchiveUserArgs;
};


export type MutationUpdateCenterArgs = {
  updateCenterArgs: UpdateCenterArgs;
};


export type MutationUpdateClientDetailsArgs = {
  updateClientDetailsArgs: UpdateClientDetailsArgs;
};


export type MutationUpdateClientPreferenceArgs = {
  updateClientPreferenceArgs: UpdateClientPreferenceArgs;
};


export type MutationUpdateClientRoleArgs = {
  addOrUpdateClientRoleArgs: AddOrUpdateClientRoleArgs;
};


export type MutationUpdateIsArchivedPatientSessionArgs = {
  updateIsArchivedPatientSessionArgs: UpdateIsArchivedPatientSessionArgs;
};


export type MutationUpdateLineOfBusinessArgs = {
  updateLineOfBusinessArgs: UpdateLineOfBusinessArgs;
};


export type MutationUpdateNotesPatientArgs = {
  updateNotesPatientArgs: UpdateNotesPatientArgs;
};


export type MutationUpdatePartnerAppArgs = {
  updatePartnerAppArgs: UpdatePartnerAppArgs;
};


export type MutationUpdatePatientArgs = {
  updatePatientArgs: UpdatePatientArgs;
};


export type MutationUpdatePatientCenterArgs = {
  updatePatientCenterArgs: UpdatePatientCenterArgs;
};


export type MutationUpdatePatientOutreachReasonArgs = {
  updatePatientOutreachReasonArgs: UpdatePatientOutreachReasonArgs;
};


export type MutationUpdatePatientReassuranceStatusArgs = {
  updatePatientReassuranceStatusArgs: UpdatePatientReassuranceStatusArgs;
};


export type MutationUpdatePatientRelatedCallArgs = {
  updatePatientRelatedCallArgs: UpdatePatientRelatedCallArgs;
};


export type MutationUpdateProfileArgs = {
  updateProfileArgs: UpdateProfileArgs;
};


export type MutationUpdateQuickLinkByIdArgs = {
  updateQuickLinkById: UpdateQuicklinkByIdArgs;
};


export type MutationUpdateScheduleArgs = {
  updateScheduleArgs: UpdateScheduleArgs;
};


export type MutationUpdateSelfServiceReportTemplateArgs = {
  args: UpdateSelfServiceReportTemplateArgs;
};


export type MutationUpdateUserRoleArgs = {
  updateUserRoleArgs: UpdateUserRoleArgs;
};


export type MutationVerifyUserOtpArgs = {
  verifyUserOtpArgs: VerifyUserOtpArgs;
};

export type NeedsClientNameArgs = {
  clientName: Scalars['String'];
};

export type NotificationPayload = {
  __typename?: 'NotificationPayload';
  createdAt: Scalars['String'];
  message: Scalars['String'];
  read?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

export type NotificationPayloadArgs = {
  clientName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  message: Scalars['String'];
  read?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

export type PartnerAppCredentials = {
  __typename?: 'PartnerAppCredentials';
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
};

export type PartnerAppInfo = {
  __typename?: 'PartnerAppInfo';
  allowedApiScopes: Array<Scalars['String']>;
  allowedLineCalledKeywords: Array<Scalars['String']>;
  appType: Scalars['String'];
  clientId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  name: Scalars['String'];
  revokedAt?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type Patient = {
  __typename?: 'Patient';
  assignedUserId: Scalars['Int'];
  caseNum?: Maybe<Scalars['String']>;
  clientId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  ipAddress?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  requiresFollowUp?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type PatientCaseFormSession = {
  __typename?: 'PatientCaseFormSession';
  age?: Maybe<Scalars['String']>;
  ageGroup?: Maybe<Scalars['String']>;
  assignedUserEmail?: Maybe<Scalars['String']>;
  assignedUserId: Scalars['Int'];
  assignedUserName?: Maybe<Scalars['String']>;
  assignedUserPhoneName?: Maybe<Scalars['String']>;
  caseformDate?: Maybe<Scalars['String']>;
  caseformLineCalled?: Maybe<Scalars['String']>;
  caseformTimeOn?: Maybe<Scalars['String']>;
  contactIpAddress?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  gender?: Maybe<Scalars['String']>;
  hasRelatedCall?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  imminentRiskSuicidal?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  patientId: Scalars['Int'];
  qualityPercent?: Maybe<Scalars['Float']>;
  questionAnswers?: Maybe<Scalars['JSON']>;
  rank?: Maybe<Scalars['Float']>;
  session: Scalars['Int'];
  state?: Maybe<Scalars['String']>;
  uniqueId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedByUserEmail?: Maybe<Scalars['String']>;
  updatedByUserId: Scalars['Int'];
  updatedByUserName?: Maybe<Scalars['String']>;
  updatedByUserPhoneName?: Maybe<Scalars['String']>;
};

export type PatientCenter = {
  __typename?: 'PatientCenter';
  assignedPrimary?: Maybe<Scalars['Boolean']>;
  assignedSecondary?: Maybe<Scalars['Boolean']>;
  centerId: Scalars['Int'];
};

export type PatientNewSessionSet = {
  __typename?: 'PatientNewSessionSet';
  patient: Patient;
  sessionNumber: Scalars['Int'];
};

export type PatientOutreachReason = {
  __typename?: 'PatientOutreachReason';
  compliance: Scalars['String'];
  id: Scalars['Int'];
  patientId: Scalars['Int'];
  reasonForCall: Scalars['String'];
  session: Scalars['Int'];
};

export type PatientQualityChecks = {
  __typename?: 'PatientQualityChecks';
  patientId: Scalars['Int'];
  percent: Scalars['Float'];
  session: Scalars['Int'];
};

export type PatientQuestionAnswer = {
  __typename?: 'PatientQuestionAnswer';
  answer?: Maybe<Scalars['String']>;
  assignedUser: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  patientName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  question: Scalars['String'];
};

export type PatientQuestionAnswerUrl = {
  __typename?: 'PatientQuestionAnswerURL';
  downloadDataBase64?: Maybe<Scalars['String']>;
  downloadFileName?: Maybe<Scalars['String']>;
  downloadURL?: Maybe<Scalars['String']>;
  exportHistoryId?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type PatientReassuranceStatus = {
  __typename?: 'PatientReassuranceStatus';
  endDate: Scalars['String'];
  enteredBy: Scalars['String'];
  note: Scalars['String'];
  patientId: Scalars['Int'];
  reassuranceStatusId: Scalars['Int'];
  startDate: Scalars['String'];
  status: Scalars['String'];
};

export type PatientRelatedCall = {
  __typename?: 'PatientRelatedCall';
  agency: Scalars['String'];
  callDate: Scalars['String'];
  callType?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  patientId: Scalars['Int'];
  phone: Scalars['String'];
  requireFollowUp?: Maybe<Scalars['Boolean']>;
  scheduleId?: Maybe<Scalars['Int']>;
  session: Scalars['Int'];
  timeInOut: Scalars['String'];
  timeOff: Scalars['String'];
  timeOn: Scalars['String'];
  toFrom: Scalars['String'];
  worker: Scalars['String'];
};

export type PatientSchedule = {
  __typename?: 'PatientSchedule';
  allowIdentifyOurself?: Maybe<Scalars['Boolean']>;
  allowVoicemailMessagesLeft?: Maybe<Scalars['Boolean']>;
  consentToBeContacted?: Maybe<Scalars['Boolean']>;
  dateEnd?: Maybe<Scalars['String']>;
  dateStart: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  primaryAssignedUserId?: Maybe<Scalars['Float']>;
  recurrence: Scalars['String'];
  scheduleType: Scalars['String'];
  secondaryAssignedUserId?: Maybe<Scalars['Float']>;
  sendEmailNotification?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type PatientSession = {
  __typename?: 'PatientSession';
  assignedUserEmail: Scalars['String'];
  assignedUserId: Scalars['Int'];
  assignedUserName?: Maybe<Scalars['String']>;
  assignedUserPhoneName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  isArchived?: Maybe<Scalars['Boolean']>;
  patientId: Scalars['Int'];
  scheduleId?: Maybe<Scalars['Float']>;
  scheduleType?: Maybe<Scalars['String']>;
  session: Scalars['Int'];
  uniqueId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedByUserEmail: Scalars['String'];
  updatedByUserName?: Maybe<Scalars['String']>;
  updatedByUserPhoneName?: Maybe<Scalars['String']>;
};

export type PatientSessionList = {
  __typename?: 'PatientSessionList';
  patientId: Scalars['Int'];
  scheduleId?: Maybe<Scalars['Float']>;
  scheduleType?: Maybe<Scalars['String']>;
  session: Scalars['Int'];
};

export type PatientSessionQuestionSet = {
  __typename?: 'PatientSessionQuestionSet';
  perm: Scalars['Int'];
  questionSet: Array<QuestionSet>;
  sessionNumber: Scalars['Int'];
};

export type PatientSessionQuestionsMap = {
  __typename?: 'PatientSessionQuestionsMap';
  questions: Scalars['JSON'];
  session: Scalars['Int'];
};

export type PdfBuildArgs = {
  buildFormat: Scalars['String'];
  clientName: Scalars['String'];
  id?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
};

export enum Privileges {
  Api = 'API',
  Developer = 'DEVELOPER',
  OtpUnverified = 'OTP_UNVERIFIED',
  Private = 'PRIVATE',
  Protected = 'PROTECTED',
  Public = 'PUBLIC',
  System = 'SYSTEM'
}

export type Profile = {
  __typename?: 'Profile';
  age?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['Int'];
  currentPatientId?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['Int']>;
  hasGuidelines: Scalars['Boolean'];
  hasSafetyPlan: Scalars['Boolean'];
  id: Scalars['Int'];
  ipAddress?: Maybe<Scalars['String']>;
  isAttemptSurvivor: Scalars['Boolean'];
  isHighRisk: Scalars['Boolean'];
  isHomicidal: Scalars['Boolean'];
  isSwatting: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  originPatientId: Scalars['Int'];
  phone?: Maybe<Scalars['String']>;
  reviewRequired: Scalars['Boolean'];
  source?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['Int'];
  uuid: Scalars['String'];
};

export type ProfileTimelineActivity = {
  __typename?: 'ProfileTimelineActivity';
  activityType: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  entityId?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  patientId?: Maybe<Scalars['Int']>;
  profileId?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
  questionId?: Maybe<Scalars['Int']>;
  session?: Maybe<Scalars['Int']>;
  summary?: Maybe<Scalars['String']>;
};

export type ProfileTimelineResponse = {
  __typename?: 'ProfileTimelineResponse';
  activities: Array<ProfileTimelineActivity>;
  totalCount: Scalars['Int'];
};

export type ProfilesResponse = {
  __typename?: 'ProfilesResponse';
  profiles: Array<Profile>;
  totalCount: Scalars['Int'];
};

export type ProfilesWithLinkedProfiles = {
  __typename?: 'ProfilesWithLinkedProfiles';
  linkedProfiles?: Maybe<Array<Profile>>;
  profile?: Maybe<Profile>;
};

export type QualityPercentPatientsArgs = {
  patientId: Scalars['Int'];
  session: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  exportClientRelatedCalls: PatientQuestionAnswerUrl;
  exportClientResources: PatientQuestionAnswerUrl;
  exportResourceReportsBundle: PatientQuestionAnswerUrl;
  getAgeDistribution: Array<Scalars['JSONObject']>;
  getAllAnswersByQuestionId: Array<Scalars['String']>;
  getAllCaseForm: Array<Patient>;
  getAllCaseFormSessions: Array<PatientCaseFormSession>;
  getAllCenterByServices: Array<CenterInfo>;
  getAllCenters: Array<CenterInfo>;
  getAllClients: Array<Client>;
  getAllPatientsQuestionAnswer: PatientQuestionAnswerUrl;
  getAllPatientsQuestionAnswerCount: Scalars['Float'];
  getAllPatientsQuestionAnswerData: Array<PatientQuestionAnswer>;
  getAllQuestions: Array<QuestionGrouped>;
  getAllServices: Array<Service>;
  getAllUserRoles: Array<Roles>;
  getAllUsers: Array<User>;
  getAllUsersByClientName: Array<User>;
  getCallCountAndPctIncrease: CallCountAndPctIncrease;
  getCallCounts: Array<CallCounts>;
  getCallCountsByTime: Array<CallCountsByTime>;
  getCaseformQualityPercent: Scalars['Float'];
  getCaseformQualityPercentByPatientIds: Array<PatientQualityChecks>;
  getCaseformSessionsWithPatientsAndQuestions: Array<Scalars['JSONObject']>;
  getCenter: Center;
  getCenterPatientAvgTimeByDay: Array<CenterPatientAvgTimeByDay>;
  getCenterReferralVerificationStatus: CenterReferralVerificationStatus;
  getCentersInfoByPatientId: Array<Center>;
  getClient3cxInfo: Client3cxInfo;
  getClientDetails: Client;
  getClientExports: Array<ClientExport>;
  getClientFeaturesAccesses: Array<ClientFeaturesAccess>;
  getClientPreference: ClientPreference;
  getClientPublicDetails: ClientPublic;
  getClientQuestions: Array<ClientQuestions>;
  getClientQuestionsByCategory: Array<ClientQuestions>;
  getClientQuestionsForExport: Array<ClientQuestions>;
  getClientRoleByUserIds: Array<UserIdsWithUserRolePrivileges>;
  getClientRolePrivileges: Array<UserRolePrivileges>;
  getClientRoles: Array<ClientRole>;
  getCovidCountAndPctIncrease: CovidCountAndPctIncrease;
  getCovidCounts: Array<CovidCounts>;
  getCrisisDashboard: CrisisDashboard;
  getCrisisMetricsDictionary: CrisisMetricsDictionary;
  getCurrentUserClientRoles: Array<UserRolePrivileges>;
  getDailyOpsDashboard: DailyOpsDashboard;
  getExportBuildPatientQuestionsMap: PatientSessionQuestionsMap;
  getIntegrations: ClientIntegrations;
  getLinesOfBusiness: Array<LineOfBusiness>;
  getLinkedProfilesById: Array<Profile>;
  getMostUsedReassuranceCompliance: Array<MostUsedReassuranceCompliance>;
  getNotificationsById: Array<NotificationPayload>;
  getPartnerApps: Array<PartnerAppInfo>;
  getPatientCenters: Array<PatientCenter>;
  getPatientDataFiles: Array<S3Files>;
  getPatientInfo: Array<Patient>;
  getPatientInfoById?: Maybe<Patient>;
  getPatientOutreachReason: Array<PatientOutreachReason>;
  getPatientQuestions: PatientSessionQuestionSet;
  getPatientQuestionsMap: PatientSessionQuestionsMap;
  getPatientReassuranceStatus: Array<PatientReassuranceStatus>;
  getPatientRelatedCalls: Array<PatientRelatedCall>;
  getPatientResourceTimeline: ProfileTimelineResponse;
  getPatientSessionList: Array<PatientSessionList>;
  getPatientSessionsByPatientId: Array<PatientSession>;
  getPatientsByClientId: Array<Patient>;
  getProfileById: Profile;
  getProfileByPatientId: ProfilesWithLinkedProfiles;
  getProfileTimeline: ProfileTimelineResponse;
  getProfiles: ProfilesResponse;
  getQuicklinkById: QuickLink;
  getQuicklinks: Array<QuickLink>;
  getReAssuranceLinePatientByAge: Array<ReAssuranceLinePatientByAge>;
  getReAssuranceLinePatientUseByDay: Array<ReAssuranceLinePatientUseByDay>;
  getReferralForVerification?: Maybe<ReferralVerificationInfo>;
  getResourceAnalyticsDashboard: ResourceAnalyticsDashboard;
  getResourceCatalogDashboard: ResourceCatalogDashboard;
  getResourceCatalogFilterOptions: ResourceCatalogFilterOptions;
  getResourceReferralClaimsBy: Array<ResourceReferralClaim>;
  getResourceReferrals: Array<ResourceReferral>;
  getScheduleById: ScheduleInfo;
  getScheduleByPatient?: Maybe<PatientSchedule>;
  getScheduleByRelatedCall?: Maybe<PatientSchedule>;
  getSchedules: Array<Schedule>;
  getSelfServiceReportExportHistory: SelfServiceReportExportHistoryPage;
  getSelfServiceReportTemplates: Array<SelfServiceReportTemplate>;
  getSessionsForReports: SessionsForReportsResult;
  getSevenMostPopularCenters: Array<SevenMostPopularCenters>;
  getSevenMostPopularServices: Array<SevenMostPopularServices>;
  getSuicidalCounts: Array<SuicidalCounts>;
  getSuicideCountAndPctIncrease: SuicideCountAndPctIncrease;
  getTableauToken: Scalars['String'];
  getThreeCxLineConfig: Array<ThreeCxLineConfig>;
  getTopSevenReassuranceReasonForCall: Array<TopSevenReassuranceReasonForCall>;
  getUserById: User;
  getUserSettings: UserSettings;
  getUsersByIds: Array<User>;
  getWorkerAvgTimeByDay: Array<WorkerAvgTimeByDay>;
  sendScheduleNotificationByScheduleId: Scalars['Boolean'];
};


export type QueryExportClientRelatedCallsArgs = {
  exportClientRelatedCallsArgs: ExportClientRelatedCallsArgs;
};


export type QueryExportClientResourcesArgs = {
  exportClientResourcesArgs: ExportClientResourcesArgs;
};


export type QueryExportResourceReportsBundleArgs = {
  generateResourceReportsBundleArgs: GenerateResourceReportsBundleArgs;
};


export type QueryGetAgeDistributionArgs = {
  getAgeDistributionArgs: GetClientAnalyticsArgs;
};


export type QueryGetAllAnswersByQuestionIdArgs = {
  getAllAnswersByQuestionIdArgs: GetAllAnswersByQuestionIdArgs;
};


export type QueryGetAllCaseFormArgs = {
  getAllCaseFormArgs: GetAllCaseFormArgs;
};


export type QueryGetAllCaseFormSessionsArgs = {
  getAllCaseFormSessionsArgs: GetAllCaseFormSessionsArgs;
};


export type QueryGetAllCenterByServicesArgs = {
  getAllCenterByServicesArgs: GetAllCenterByServicesArgs;
};


export type QueryGetAllCentersArgs = {
  getAllCentersArgs: GetAllCentersArgs;
};


export type QueryGetAllPatientsQuestionAnswerArgs = {
  getAllPatientsQuestionAnswerArgs: GetAllPatientsQuestionAnswerArgs;
};


export type QueryGetAllPatientsQuestionAnswerDataArgs = {
  getAllPatientsQuestionAnswerArgs: GetAllPatientsQuestionAnswerDataArgs;
};


export type QueryGetAllUsersArgs = {
  getAllUsersArgs: GetAllUsersArgs;
};


export type QueryGetAllUsersByClientNameArgs = {
  getAllUsersByClientNameArgs: GetAllUsersByClientNameArgs;
};


export type QueryGetCallCountAndPctIncreaseArgs = {
  getCallCountAndPctIncreaseArgs: GetClientAnalyticsArgs;
};


export type QueryGetCallCountsArgs = {
  getCallCountsArgs: GetClientAnalyticsArgs;
};


export type QueryGetCallCountsByTimeArgs = {
  getCallCountsByTimeArgs: GetClientAnalyticsArgs;
};


export type QueryGetCaseformQualityPercentArgs = {
  getCaseformQualityPercentArgs: GetCaseformQualityPercentArgs;
};


export type QueryGetCaseformQualityPercentByPatientIdsArgs = {
  getCaseformQualityPercentByPatientsArgs: GetCaseformQualityPercentByPatientsArgs;
};


export type QueryGetCaseformSessionsWithPatientsAndQuestionsArgs = {
  getCaseformSessionsWithPatientsAndQuestionsArgs: GetCaseformSessionsWithPatientsAndQuestionsArgs;
};


export type QueryGetCenterArgs = {
  getCenterArgs: GetCenterArgs;
};


export type QueryGetCenterPatientAvgTimeByDayArgs = {
  getCenterPatientAvgTimeByDayArgs: GetClientAnalyticsArgs;
};


export type QueryGetCenterReferralVerificationStatusArgs = {
  getCenterReferralVerificationStatusArgs: GetCenterReferralVerificationStatusArgs;
};


export type QueryGetCentersInfoByPatientIdArgs = {
  getCentersInfoByPatientIdArgs: GetCentersInfoByPatientIdArgs;
};


export type QueryGetClient3cxInfoArgs = {
  needsClientNameArgs: NeedsClientNameArgs;
};


export type QueryGetClientDetailsArgs = {
  getClientDetailsArgs: GetClientDetailsArgs;
};


export type QueryGetClientExportsArgs = {
  getExportArgs: GetExportArgs;
};


export type QueryGetClientFeaturesAccessesArgs = {
  getClientFeaturesAccessArgs: GetClientFeaturesAccessArgs;
};


export type QueryGetClientPreferenceArgs = {
  getClientPreferenceArgs: GetClientPreferenceArgs;
};


export type QueryGetClientPublicDetailsArgs = {
  getClientDetailsArgs: GetClientDetailsArgs;
};


export type QueryGetClientQuestionsArgs = {
  getClientQuestionsArgs: GetClientQuestionsArgs;
};


export type QueryGetClientQuestionsByCategoryArgs = {
  getClientQuestionsArgs: GetClientQuestionsByCategoryArgs;
};


export type QueryGetClientQuestionsForExportArgs = {
  getClientQuestionsArgs: GetClientQuestionsArgs;
};


export type QueryGetClientRoleByUserIdsArgs = {
  getClientRolesByUserIdsArgs: GetClientRolesByUserIdsArgs;
};


export type QueryGetClientRolePrivilegesArgs = {
  getClientRolePrivilegesArgs: GetClientRolePrivilegesArgs;
};


export type QueryGetClientRolesArgs = {
  getClientRolesArgs: GetClientRolesArgs;
};


export type QueryGetCovidCountAndPctIncreaseArgs = {
  getCovidCountAndPctIncreaseArgs: GetClientAnalyticsArgs;
};


export type QueryGetCovidCountsArgs = {
  getCovidCountsArgs: GetClientAnalyticsArgs;
};


export type QueryGetCrisisDashboardArgs = {
  getCrisisDashboardArgs: GetCrisisDashboardArgs;
};


export type QueryGetCurrentUserClientRolesArgs = {
  getCurrentUserClientRolesArgs: GetCurrentUserClientRolesArgs;
};


export type QueryGetDailyOpsDashboardArgs = {
  getDailyOpsDashboardArgs: GetDailyOpsDashboardArgs;
};


export type QueryGetExportBuildPatientQuestionsMapArgs = {
  getExportBuildPatientQuestionsMapArgs: GetExportBuildPatientQuestionsMapArgs;
};


export type QueryGetIntegrationsArgs = {
  needsClientNameArgs: NeedsClientNameArgs;
};


export type QueryGetLinesOfBusinessArgs = {
  needsClientNameArgs: NeedsClientNameArgs;
};


export type QueryGetLinkedProfilesByIdArgs = {
  getLinkedProfilesByIdArgs: GetLinkedProfilesByIdArgs;
};


export type QueryGetMostUsedReassuranceComplianceArgs = {
  getMostUsedReassuranceComplianceArgs: GetClientAnalyticsArgs;
};


export type QueryGetNotificationsByIdArgs = {
  getNotificationsByIdArgs: GetNotificationsByIdArgs;
};


export type QueryGetPartnerAppsArgs = {
  needsClientNameArgs: NeedsClientNameArgs;
};


export type QueryGetPatientCentersArgs = {
  getPatientCenterArgs: GetPatientCenterArgs;
};


export type QueryGetPatientDataFilesArgs = {
  awsS3DefaultArgs: AwsS3DefaultArgs;
};


export type QueryGetPatientInfoArgs = {
  getPatientInfoArgs: GetPatientInfoArgs;
};


export type QueryGetPatientInfoByIdArgs = {
  getPatientInfoByIdArgs: GetPatientInfoByIdArgs;
};


export type QueryGetPatientOutreachReasonArgs = {
  getPatientOutreachReasonArgs: GetPatientOutreachReasonArgs;
};


export type QueryGetPatientQuestionsArgs = {
  getPatientQuestionAnswerArgs: GetPatientQuestionAnswerArgs;
};


export type QueryGetPatientQuestionsMapArgs = {
  getPatientQuestionAnswerArgs: GetPatientQuestionAnswerArgs;
};


export type QueryGetPatientReassuranceStatusArgs = {
  getPatientReassuranceStatusArgs: GetPatientReassuranceStatusArgs;
};


export type QueryGetPatientRelatedCallsArgs = {
  getPatientRelatedCallsArgs: GetPatientRelatedCallsArgs;
};


export type QueryGetPatientResourceTimelineArgs = {
  getProfileTimelineArgs: GetProfileTimelineArgs;
};


export type QueryGetPatientSessionListArgs = {
  getPatientSessionsByArgs: GetPatientSessionsByArgs;
};


export type QueryGetPatientSessionsByPatientIdArgs = {
  getPatientSessionsByPatientIdArgs: GetPatientSessionsByPatientIdArgs;
};


export type QueryGetPatientsByClientIdArgs = {
  getPatientsByClientIdArgs: GetPatientsByClientIdArgs;
};


export type QueryGetProfileByIdArgs = {
  getProfileByIdArgs: GetProfileByIdArgs;
};


export type QueryGetProfileByPatientIdArgs = {
  getProfileByPatientIdArgs: GetProfileByPatientIdArgs;
};


export type QueryGetProfileTimelineArgs = {
  getProfileTimelineArgs: GetProfileTimelineArgs;
};


export type QueryGetProfilesArgs = {
  getProfilesArgs: GetProfilesArgs;
};


export type QueryGetQuicklinkByIdArgs = {
  getQuicklinkById: GetQuicklinkByIdArgs;
};


export type QueryGetQuicklinksArgs = {
  getQuicklinks: GetQuicklinksArgs;
};


export type QueryGetReAssuranceLinePatientByAgeArgs = {
  getReAssuranceLinePatientByAgeArgs: GetClientAnalyticsArgs;
};


export type QueryGetReAssuranceLinePatientUseByDayArgs = {
  getReAssuranceLinePatientUseByDayArgs: GetClientAnalyticsArgs;
};


export type QueryGetReferralForVerificationArgs = {
  getReferralForVerificationArgs: GetReferralForVerificationArgs;
};


export type QueryGetResourceAnalyticsDashboardArgs = {
  getResourceAnalyticsDashboardArgs: GetResourceAnalyticsArgs;
};


export type QueryGetResourceCatalogDashboardArgs = {
  getResourceCatalogDashboardArgs: GetResourceCatalogDashboardArgs;
};


export type QueryGetResourceCatalogFilterOptionsArgs = {
  getResourceCatalogFilterOptionsArgs: GetResourceCatalogFilterOptionsArgs;
};


export type QueryGetResourceReferralClaimsByArgs = {
  getReferralClaimsByReferralResourceIdArgs: GetReferralClaimsByReferralResourceIdArgs;
};


export type QueryGetResourceReferralsArgs = {
  getResourceReferralsArgs: GetResourceReferralsArgs;
};


export type QueryGetScheduleByIdArgs = {
  getScheduleByIdArgs: GetScheduleByIdArgs;
};


export type QueryGetScheduleByPatientArgs = {
  getScheduleByPatientArgs: GetScheduleByPatientArgs;
};


export type QueryGetScheduleByRelatedCallArgs = {
  getScheduleByRelatedCallArgs: GetScheduleByRelatedCallArgs;
};


export type QueryGetSchedulesArgs = {
  getScheduleArgs: GetScheduleArgs;
};


export type QueryGetSelfServiceReportExportHistoryArgs = {
  args: GetSelfServiceReportExportHistoryArgs;
};


export type QueryGetSelfServiceReportTemplatesArgs = {
  needsClientNameArgs: NeedsClientNameArgs;
};


export type QueryGetSessionsForReportsArgs = {
  getSessionsForReportsArgs: GetSessionsForReportsArgs;
};


export type QueryGetSevenMostPopularCentersArgs = {
  getSevenMostPopularCentersArgs: GetClientAnalyticsArgs;
};


export type QueryGetSevenMostPopularServicesArgs = {
  getSevenMostPopularServicesArgs: GetClientAnalyticsArgs;
};


export type QueryGetSuicidalCountsArgs = {
  getSuicidalCountsArgs: GetClientAnalyticsArgs;
};


export type QueryGetSuicideCountAndPctIncreaseArgs = {
  getSuicideCountAndPctIncreaseArgs: GetClientAnalyticsArgs;
};


export type QueryGetThreeCxLineConfigArgs = {
  needsClientNameArgs: NeedsClientNameArgs;
};


export type QueryGetTopSevenReassuranceReasonForCallArgs = {
  getTopSevenReassuranceReasonForCallArgs: GetClientAnalyticsArgs;
};


export type QueryGetUserByIdArgs = {
  getUserByIdArgs: GetUserByIdArgs;
};


export type QueryGetUsersByIdsArgs = {
  getUsersByIdsArgs: GetUsersByIdsArgs;
};


export type QueryGetWorkerAvgTimeByDayArgs = {
  getWorkerAvgTimeByDayArgs: GetClientAnalyticsArgs;
};


export type QuerySendScheduleNotificationByScheduleIdArgs = {
  getScheduleByIdArgs: GetScheduleByIdArgs;
};

export type Question = {
  __typename?: 'Question';
  category: Scalars['String'];
  id: Scalars['Int'];
  isEnabled: Scalars['Boolean'];
  question: Scalars['String'];
  questionType: QuestionTypesEnum;
};

export type QuestionGrouped = {
  __typename?: 'QuestionGrouped';
  category: Scalars['String'];
  questions: Array<Question>;
};

export type QuestionSet = {
  __typename?: 'QuestionSet';
  answer: Scalars['String'];
  id: Scalars['Int'];
  question: Scalars['String'];
};

export enum QuestionTypesEnum {
  Checkbox = 'CHECKBOX',
  Dropdown = 'DROPDOWN',
  Text = 'TEXT',
  YesNoUnknown = 'YES_NO_UNKNOWN',
  YesOrNo = 'YES_OR_NO'
}

export type QuickLink = {
  __typename?: 'QuickLink';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  createdById: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
  updatedById: Scalars['Float'];
  url: Scalars['String'];
};

export type ReAssuranceLinePatientByAge = {
  __typename?: 'ReAssuranceLinePatientByAge';
  age: Scalars['String'];
  useCount: Scalars['Int'];
};

export type ReAssuranceLinePatientUseByDay = {
  __typename?: 'ReAssuranceLinePatientUseByDay';
  date: Scalars['String'];
  useCount: Scalars['Int'];
};

export type RecordSelfServiceReportDownloadArgs = {
  clientName: Scalars['String'];
  exportHistoryId: Scalars['Int'];
};

/** Referral verification aspect / dispatch type (request_type on resource_referrals) */
export enum ReferralAspect {
  AllowCallerInfo = 'ALLOW_CALLER_INFO',
  AllowReferrals = 'ALLOW_REFERRALS',
  Contact = 'CONTACT',
  Resource = 'RESOURCE',
  SendCallerInfo = 'SEND_CALLER_INFO'
}

export type ReferralClaimCoverage = {
  __typename?: 'ReferralClaimCoverage';
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  iid?: Maybe<Scalars['String']>;
  levelCount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type ReferralVerificationInfo = {
  __typename?: 'ReferralVerificationInfo';
  aspect?: Maybe<ReferralAspect>;
  center?: Maybe<Center>;
  confirmStatus: Scalars['String'];
  contactEmail?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  requestType: Scalars['String'];
  titleRole?: Maybe<Scalars['String']>;
};

export type ReferralVerificationResponse = {
  __typename?: 'ReferralVerificationResponse';
  alreadyResponded: Scalars['Boolean'];
  success: Scalars['Boolean'];
};

export type RefreshTokenArgs = {
  token: Scalars['String'];
};

export type RemovePatientFromPatientGroupArgs = {
  clientName: Scalars['String'];
  groupId: Scalars['Int'];
  patientId: Scalars['Int'];
};

export type RequestReferralVerificationArgs = {
  aspect: ReferralAspect;
  centerId: Scalars['Int'];
  clientName: Scalars['String'];
  contactEmail?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isReminder?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  titleRole?: InputMaybe<Scalars['String']>;
};

export type ResetOtpUserArgs = {
  userId: Scalars['Int'];
};

export type ResetPasswordArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};

export type ResourceAnalyticsDashboard = {
  __typename?: 'ResourceAnalyticsDashboard';
  assignmentSegmentation: ResourceAssignmentSegmentation;
  callerHeatmapPoints: Array<ResourceCallerHeatmapPoint>;
  centerHeatmapBuckets: Array<ResourceCenterHeatmapBucket>;
  dispositionBreakdown: Array<ResourceDispositionBreakdown>;
  distributionByService: Array<ResourceDistributionByService>;
  giveOutByCenter: Array<ResourceGiveOutByCenter>;
  summary: ResourceAnalyticsSummary;
};

export type ResourceAnalyticsSummary = {
  __typename?: 'ResourceAnalyticsSummary';
  totalResourcesGiven: Scalars['Int'];
  uniqueCentersGiven: Scalars['Int'];
  uniqueSessionsWithResources: Scalars['Int'];
};

export type ResourceAssignmentSegmentation = {
  __typename?: 'ResourceAssignmentSegmentation';
  both: Scalars['Int'];
  neither: Scalars['Int'];
  primaryOnly: Scalars['Int'];
  secondaryOnly: Scalars['Int'];
};

export type ResourceCallerHeatmapPoint = {
  __typename?: 'ResourceCallerHeatmapPoint';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  weight: Scalars['Int'];
};

export type ResourceCatalogAddress = {
  __typename?: 'ResourceCatalogAddress';
  centerId: Scalars['Int'];
  city: Scalars['String'];
  county?: Maybe<Scalars['String']>;
  eligibility?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  serviceNames: Array<Scalars['String']>;
  state: Scalars['String'];
  streetAddress: Scalars['String'];
  zipCode?: Maybe<Scalars['String']>;
};

export type ResourceCatalogDashboard = {
  __typename?: 'ResourceCatalogDashboard';
  addresses: Array<ResourceCatalogAddress>;
  centerHeatmapBuckets: Array<ResourceCenterHeatmapBucket>;
  distributionByService: Array<ResourceDistributionByService>;
  summary: ResourceCatalogSummary;
};

export type ResourceCatalogFilterOptions = {
  __typename?: 'ResourceCatalogFilterOptions';
  services: Array<Service>;
};

export type ResourceCatalogSummary = {
  __typename?: 'ResourceCatalogSummary';
  resourceCount: Scalars['Int'];
  resourcesWithServicesCount: Scalars['Int'];
  resourcesWithoutServicesCount: Scalars['Int'];
};

export type ResourceCenterHeatmapBucket = {
  __typename?: 'ResourceCenterHeatmapBucket';
  count: Scalars['Int'];
  county?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type ResourceDispositionBreakdown = {
  __typename?: 'ResourceDispositionBreakdown';
  label: Scalars['String'];
  questionKey: Scalars['String'];
  yesCount: Scalars['Int'];
};

export type ResourceDistributionByService = {
  __typename?: 'ResourceDistributionByService';
  count: Scalars['Int'];
  serviceName: Scalars['String'];
};

export type ResourceGiveOutByCenter = {
  __typename?: 'ResourceGiveOutByCenter';
  centerId: Scalars['Int'];
  centerName: Scalars['String'];
  giveOutCount: Scalars['Int'];
};

export type ResourceReferral = {
  __typename?: 'ResourceReferral';
  callerEmail?: Maybe<Scalars['String']>;
  callerName?: Maybe<Scalars['String']>;
  callerPhone?: Maybe<Scalars['String']>;
  centerAddress?: Maybe<Scalars['String']>;
  centerName?: Maybe<Scalars['String']>;
  changeLog?: Maybe<Scalars['String']>;
  claimIsCompleted?: Maybe<Scalars['Boolean']>;
  confirmStatus: Scalars['String'];
  contactEmail?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  deliveryStatus?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['Int']>;
  requestType: Scalars['String'];
  resourceId: Scalars['Int'];
  respondedDate?: Maybe<Scalars['DateTime']>;
  sentByUser?: Maybe<User>;
  sentByUserId: Scalars['Float'];
  sentDate?: Maybe<Scalars['DateTime']>;
  sessionNumber?: Maybe<Scalars['Int']>;
  titleRole?: Maybe<Scalars['String']>;
};

export type ResourceReferralClaim = {
  __typename?: 'ResourceReferralClaim';
  address?: Maybe<Scalars['String']>;
  coverages: Array<ReferralClaimCoverage>;
  dateOfBirth?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isCompleted: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['Float']>;
  resourceReferralId: Scalars['String'];
};

export type RespondToReferralUpdateArgs = {
  clientName: Scalars['String'];
  contactEmail?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<Scalars['String']>;
  resourceAltName?: InputMaybe<Scalars['String']>;
  resourceApplicationProcedure?: InputMaybe<Scalars['String']>;
  resourceCity?: InputMaybe<Scalars['String']>;
  resourceDescription?: InputMaybe<Scalars['String']>;
  resourceEligibility?: InputMaybe<Scalars['String']>;
  resourceEmailAddress?: InputMaybe<Scalars['String']>;
  resourceFaxNumber?: InputMaybe<Scalars['String']>;
  resourceFeeScale?: InputMaybe<Scalars['String']>;
  resourcePhoneNumber?: InputMaybe<Scalars['String']>;
  resourceState?: InputMaybe<Scalars['String']>;
  resourceStreetAddress?: InputMaybe<Scalars['String']>;
  resourceWebsiteAddress?: InputMaybe<Scalars['String']>;
  resourceWebsiteNotes?: InputMaybe<Scalars['String']>;
  resourceZipCode?: InputMaybe<Scalars['String']>;
  titleRole?: InputMaybe<Scalars['String']>;
};

export type RespondToReferralVerificationArgs = {
  clientName: Scalars['String'];
  id: Scalars['String'];
  response: Scalars['String'];
};

export type RevokePartnerAppArgs = {
  clientId: Scalars['String'];
  clientName: Scalars['String'];
};

export enum Roles {
  ClientAdmin = 'CLIENT_ADMIN',
  ClientMember = 'CLIENT_MEMBER',
  ClientSales = 'CLIENT_SALES',
  None = 'NONE',
  ResolvexAdmin = 'RESOLVEX_ADMIN',
  ResolvexMember = 'RESOLVEX_MEMBER'
}

export type RotatePartnerSecretArgs = {
  clientId: Scalars['String'];
  clientName: Scalars['String'];
};

export type S3Files = {
  __typename?: 'S3Files';
  dateModified?: Maybe<Scalars['DateTime']>;
  fileSize?: Maybe<Scalars['Float']>;
  url: Scalars['String'];
};

export type Schedule = {
  __typename?: 'Schedule';
  allDay?: Maybe<Scalars['Boolean']>;
  allowIdentifyOurself?: Maybe<Scalars['Boolean']>;
  allowVoicemailMessagesLeft?: Maybe<Scalars['Boolean']>;
  consentToBeContacted?: Maybe<Scalars['Boolean']>;
  dateEnd?: Maybe<Scalars['String']>;
  dateStart: Scalars['String'];
  id: Scalars['Int'];
  linkedPatientId?: Maybe<Scalars['Int']>;
  linkedPatientSession?: Maybe<Scalars['Int']>;
  notifiedAt?: Maybe<Scalars['String']>;
  primaryAssignedUserEmail?: Maybe<Scalars['String']>;
  primaryAssignedUserId?: Maybe<Scalars['Float']>;
  recurrence?: Maybe<Scalars['String']>;
  scheduleType: Scalars['String'];
  secondaryAssignedUserEmail?: Maybe<Scalars['String']>;
  secondaryAssignedUserId?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ScheduleInfo = {
  __typename?: 'ScheduleInfo';
  allDay?: Maybe<Scalars['Boolean']>;
  allowIdentifyOurself?: Maybe<Scalars['Boolean']>;
  allowVoicemailMessagesLeft?: Maybe<Scalars['Boolean']>;
  consentToBeContacted?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  dateEnd?: Maybe<Scalars['String']>;
  dateStart: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  linkedPatientId?: Maybe<Scalars['Int']>;
  linkedPatientSession?: Maybe<Scalars['Int']>;
  notifiedAt?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['Float']>;
  primaryAssignedUserEmail?: Maybe<Scalars['String']>;
  primaryAssignedUserId?: Maybe<Scalars['Float']>;
  recurrence?: Maybe<Scalars['String']>;
  scheduleType: Scalars['String'];
  secondaryAssignedUserEmail?: Maybe<Scalars['String']>;
  secondaryAssignedUserId?: Maybe<Scalars['Float']>;
  session?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type SelfServiceReportExportHistoryEntry = {
  __typename?: 'SelfServiceReportExportHistoryEntry';
  deliveryMode: Scalars['String'];
  downloadCount: Scalars['Int'];
  firstDownloadedAt?: Maybe<Scalars['String']>;
  generatedAt: Scalars['String'];
  generatedByEmail?: Maybe<Scalars['String']>;
  generatedByUserId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  lastDownloadedAt?: Maybe<Scalars['String']>;
  requestPayloadJson: Scalars['String'];
  summaryMessage?: Maybe<Scalars['String']>;
  zipFileName: Scalars['String'];
};

export type SelfServiceReportExportHistoryPage = {
  __typename?: 'SelfServiceReportExportHistoryPage';
  items: Array<SelfServiceReportExportHistoryEntry>;
  totalCount: Scalars['Int'];
};

export type SelfServiceReportTemplate = {
  __typename?: 'SelfServiceReportTemplate';
  clientName: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  createdByUserId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  payload: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
};

export enum SelfServiceSessionArchivedFilter {
  ActiveOnly = 'ACTIVE_ONLY',
  All = 'ALL',
  ArchivedOnly = 'ARCHIVED_ONLY'
}

export type Service = {
  __typename?: 'Service';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type SessionsForReportsResult = {
  __typename?: 'SessionsForReportsResult';
  sessions: Array<PatientCaseFormSession>;
  totalCount: Scalars['Int'];
};

export type SetPatientQuestionAnswerArgs = {
  clientName: Scalars['String'];
  editedAnswer: Scalars['String'];
  patientId: Scalars['Int'];
  questionId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type SetThreeCxLineConfigArgs = {
  clientName: Scalars['String'];
  createCaseformEnabled: Scalars['Boolean'];
  dn: Scalars['String'];
};

export type SevenMostPopularCenters = {
  __typename?: 'SevenMostPopularCenters';
  centerUseCount: Scalars['Int'];
  name: Scalars['String'];
};

export type SevenMostPopularServices = {
  __typename?: 'SevenMostPopularServices';
  name: Scalars['String'];
  serviceUseCount: Scalars['Int'];
};

export type SuicidalCounts = {
  __typename?: 'SuicidalCounts';
  date: Scalars['String'];
  suicidalCount: Scalars['Int'];
};

export type SuicideCountAndPctIncrease = {
  __typename?: 'SuicideCountAndPctIncrease';
  percentIncrease: Scalars['Int'];
  suicideCountToday: Scalars['Int'];
};

export type ThreeCxLineConfig = {
  __typename?: 'ThreeCxLineConfig';
  createCaseformEnabled: Scalars['Boolean'];
  dn: Scalars['String'];
  lineName?: Maybe<Scalars['String']>;
  lineOfBusinessId?: Maybe<Scalars['Int']>;
  workflowType?: Maybe<Scalars['String']>;
};

export type ToggleIsEnableClientQuestionArgs = {
  clientName: Scalars['String'];
  id: Scalars['Int'];
  value: Scalars['Boolean'];
};

export type TopSevenReassuranceReasonForCall = {
  __typename?: 'TopSevenReassuranceReasonForCall';
  reason: Scalars['String'];
  useCount: Scalars['Int'];
};

export type UnarchiveUserArgs = {
  userId: Scalars['Int'];
};

export type UpdateCenterArgs = {
  altName?: InputMaybe<Scalars['String']>;
  applicationProcedure?: InputMaybe<Scalars['String']>;
  callerInfoAllowed?: InputMaybe<Scalars['Boolean']>;
  city: Scalars['String'];
  clientId: Scalars['Int'];
  clientName: Scalars['String'];
  county?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eligibility?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  faxNumber?: InputMaybe<Scalars['String']>;
  feeScale?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  mailingAddress?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  referralsAllowed?: InputMaybe<Scalars['Boolean']>;
  serviceIds: Array<Scalars['Int']>;
  state: Scalars['String'];
  streetAddress: Scalars['String'];
  updatedBy?: InputMaybe<Scalars['String']>;
  websiteAddress: Scalars['String'];
  websiteNotes?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateClientDetailsArgs = {
  clientId: Scalars['Int'];
  companyName: Scalars['String'];
  contactEmail: Scalars['String'];
  contactPerson: Scalars['String'];
  number: Scalars['String'];
};

export type UpdateClientPreferenceArgs = {
  clientName: Scalars['String'];
  timeCycle?: InputMaybe<Scalars['String']>;
};

export type UpdateIsArchivedPatientSessionArgs = {
  clientName: Scalars['String'];
  isArchived: Scalars['Boolean'];
  patientId: Scalars['Int'];
  session: Scalars['Int'];
};

export type UpdateLineOfBusinessArgs = {
  clientName: Scalars['String'];
  displayOrder?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  workflowType?: InputMaybe<Scalars['String']>;
};

export type UpdateNotesPatientArgs = {
  clientName: Scalars['String'];
  id: Scalars['Int'];
  notes: Scalars['String'];
};

export type UpdatePartnerAppArgs = {
  allowedApiScopes?: InputMaybe<Array<Scalars['String']>>;
  appName: Scalars['String'];
  clientId: Scalars['String'];
  clientName: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
};

export type UpdatePatientArgs = {
  assignedUserId?: InputMaybe<Scalars['Int']>;
  clientName: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  ipAddress?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdatePatientCenterArgs = {
  assignedPrimary?: InputMaybe<Scalars['Boolean']>;
  assignedSecondary?: InputMaybe<Scalars['Boolean']>;
  centerId: Scalars['Int'];
  clientName: Scalars['String'];
  patientId: Scalars['Int'];
  sessionNumber: Scalars['Int'];
};

export type UpdatePatientOutreachReasonArgs = {
  clientName: Scalars['String'];
  compliance: Scalars['String'];
  id: Scalars['Int'];
  patientId: Scalars['Int'];
  reasonForCall: Scalars['String'];
  session: Scalars['Int'];
};

export type UpdatePatientReassuranceStatusArgs = {
  clientName: Scalars['String'];
  endDate: Scalars['String'];
  enteredBy: Scalars['String'];
  note: Scalars['String'];
  patientId: Scalars['Int'];
  reassuranceStatusId: Scalars['Int'];
  startDate: Scalars['String'];
  status: Scalars['String'];
};

export type UpdatePatientRelatedCallArgs = {
  agency: Scalars['String'];
  callDate: Scalars['String'];
  callType?: InputMaybe<Scalars['String']>;
  clientName: Scalars['String'];
  contact?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  patientId: Scalars['Int'];
  phone: Scalars['String'];
  requireFollowUp?: InputMaybe<Scalars['Boolean']>;
  scheduleId?: InputMaybe<Scalars['Int']>;
  session: Scalars['Int'];
  timeInOut: Scalars['String'];
  timeOff: Scalars['String'];
  timeOn: Scalars['String'];
  toFrom: Scalars['String'];
  worker: Scalars['String'];
};

export type UpdateProfileArgs = {
  clientName: Scalars['String'];
  currentPatientId?: InputMaybe<Scalars['Int']>;
  hasGuidelines?: InputMaybe<Scalars['Boolean']>;
  hasSafetyPlan?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  isAttemptSurvivor?: InputMaybe<Scalars['Boolean']>;
  isHighRisk?: InputMaybe<Scalars['Boolean']>;
  isHomicidal?: InputMaybe<Scalars['Boolean']>;
  isSwatting?: InputMaybe<Scalars['Boolean']>;
  reviewRequired?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
};

export type UpdateQuicklinkByIdArgs = {
  clientName: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Float'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedById: Scalars['Float'];
  url: Scalars['String'];
};

export type UpdateScheduleArgs = {
  allDay: Scalars['Boolean'];
  allowIdentifyOurself?: InputMaybe<Scalars['Boolean']>;
  allowVoicemailMessagesLeft?: InputMaybe<Scalars['Boolean']>;
  clientName: Scalars['String'];
  consentToBeContacted?: InputMaybe<Scalars['Boolean']>;
  createdBy: Scalars['String'];
  dateEnd?: InputMaybe<Scalars['String']>;
  dateStart: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Float'];
  linkedPatientId?: InputMaybe<Scalars['Int']>;
  linkedPatientSession?: InputMaybe<Scalars['Int']>;
  notifiedAt?: InputMaybe<Scalars['String']>;
  organizerEmail?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['Float']>;
  primaryAssignedUserId?: InputMaybe<Scalars['Float']>;
  recurrence: Scalars['String'];
  scheduleType: Scalars['String'];
  secondaryAssignedUserId?: InputMaybe<Scalars['Float']>;
  sendEmailNotification?: InputMaybe<Scalars['Boolean']>;
  session?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedBy: Scalars['String'];
};

export type UpdateSelfServiceReportTemplateArgs = {
  clientName: Scalars['String'];
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['String']>;
};

export type UpdateUserRoleArgs = {
  newRole: Scalars['String'];
  userId: Scalars['Int'];
};

export type User = {
  __typename?: 'User';
  archived?: Maybe<Scalars['Boolean']>;
  clientId: Scalars['Int'];
  clientName: Scalars['String'];
  clientRole?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  otpEnabled?: Maybe<Scalars['Boolean']>;
  otpSecretHash?: Maybe<Scalars['String']>;
  otpVerified?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  phoneExtensionNumber?: Maybe<Scalars['String']>;
  phoneName?: Maybe<Scalars['String']>;
  privileges: Array<Privileges>;
  role: Roles;
  user_privileges: Array<UserRolePrivileges>;
  workerNumber?: Maybe<Scalars['String']>;
};

export type UserIdsWithUserRolePrivileges = {
  __typename?: 'UserIdsWithUserRolePrivileges';
  privileges: Array<UserRolePrivileges>;
  userId: Scalars['Int'];
};

export type UserRolePrivileges = {
  __typename?: 'UserRolePrivileges';
  accesses: Array<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  feature: Scalars['String'];
  id: Scalars['Int'];
  isDefault?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  keywordClass?: Maybe<Scalars['String']>;
  keywordId?: Maybe<Scalars['Int']>;
  keywordName?: Maybe<Scalars['String']>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  isOtpEnabled: Scalars['Boolean'];
};

export type VerificationAspectStatus = {
  __typename?: 'VerificationAspectStatus';
  contactEmail?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastReferralId?: Maybe<Scalars['String']>;
  lastSentAt?: Maybe<Scalars['DateTime']>;
  lastSentBy?: Maybe<User>;
  respondedDate?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  titleRole?: Maybe<Scalars['String']>;
};

export type VerifyUserOtpArgs = {
  otp: Scalars['String'];
  test?: InputMaybe<Scalars['Boolean']>;
};

export type WorkerAvgTimeByDay = {
  __typename?: 'WorkerAvgTimeByDay';
  date: Scalars['String'];
  minutes: Scalars['Int'];
};

export type AwsS3DefaultArgs = {
  clientName: Scalars['String'];
};

export type AwsS3DeleteFilesArgs = {
  fileNames: Array<Scalars['String']>;
};

export type GetPatientsByClientIdQueryVariables = Exact<{
  getPatientsByClientIdArgs: GetPatientsByClientIdArgs;
}>;


export type GetPatientsByClientIdQuery = { __typename?: 'Query', getPatientsByClientId: Array<{ __typename?: 'Patient', id: number, assignedUserId: number, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, ipAddress?: string | null | undefined, clientId: number, caseNum?: string | null | undefined, middleName?: string | null | undefined, notes?: string | null | undefined }> };

export type GetAllClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllClientsQuery = { __typename?: 'Query', getAllClients: Array<{ __typename?: 'Client', id: number, name: string, companyName: string }> };

export type GetClientDetailsQueryVariables = Exact<{
  getClientDetailsArgs: GetClientDetailsArgs;
}>;


export type GetClientDetailsQuery = { __typename?: 'Query', getClientDetails: { __typename?: 'Client', id: number, name: string, contactEmail?: string | null | undefined, number?: string | null | undefined, contactPerson?: string | null | undefined } };

export type AddClientMutationVariables = Exact<{
  addClientArgs: AddClientArgs;
}>;


export type AddClientMutation = { __typename?: 'Mutation', addClient: boolean };

export type UpdateClientDetailsMutationVariables = Exact<{
  updateClientDetailsArgs: UpdateClientDetailsArgs;
}>;


export type UpdateClientDetailsMutation = { __typename?: 'Mutation', updateClientDetails: boolean };

export type DeleteClientMutationVariables = Exact<{
  deleteClientArgs: DeleteClientArgs;
}>;


export type DeleteClientMutation = { __typename?: 'Mutation', deleteClient: boolean };

export type GetClientRolePrivilegesQueryVariables = Exact<{
  getClientRolePrivilegesArgs: GetClientRolePrivilegesArgs;
}>;


export type GetClientRolePrivilegesQuery = { __typename?: 'Query', getClientRolePrivileges: Array<{ __typename?: 'UserRolePrivileges', feature: string, category?: string | null | undefined, accesses: Array<string> }> };

export type GetCurrentUserClientRolesQueryVariables = Exact<{
  getCurrentUserClientRolesArgs: GetCurrentUserClientRolesArgs;
}>;


export type GetCurrentUserClientRolesQuery = { __typename?: 'Query', getCurrentUserClientRoles: Array<{ __typename?: 'UserRolePrivileges', feature: string, category?: string | null | undefined, accesses: Array<string>, keyword?: string | null | undefined, isDefault?: boolean | null | undefined, keywordId?: number | null | undefined, keywordClass?: string | null | undefined }> };

export type AuthenticateUserMutationVariables = Exact<{
  authenticateUserArgs: AuthenticateUserArgs;
}>;


export type AuthenticateUserMutation = { __typename?: 'Mutation', authenticateUser: string };

export type VerifyUserOtpMutationVariables = Exact<{
  verifyUserOtpArgs: VerifyUserOtpArgs;
}>;


export type VerifyUserOtpMutation = { __typename?: 'Mutation', verifyUserOtp: string };

export type ResetPasswordMutationVariables = Exact<{
  resetPasswordArgs: ResetPasswordArgs;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type RefreshTokenMutationVariables = Exact<{
  refreshTokenArgs: RefreshTokenArgs;
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken: string };

export type DeleteTokenMutationVariables = Exact<{
  deleteTokenArgs: DeleteTokenArgs;
}>;


export type DeleteTokenMutation = { __typename?: 'Mutation', deleteToken: boolean };

export type GetNotificationsByIdQueryVariables = Exact<{
  getNotificationsByIdArgs: GetNotificationsByIdArgs;
}>;


export type GetNotificationsByIdQuery = { __typename?: 'Query', getNotificationsById: Array<{ __typename?: 'NotificationPayload', title: string, message: string, read?: boolean | null | undefined, url?: string | null | undefined, createdAt: string, variant?: string | null | undefined }> };

export type AddNotificationMutationVariables = Exact<{
  notificationPayloadArgs: NotificationPayloadArgs;
}>;


export type AddNotificationMutation = { __typename?: 'Mutation', addNotification: boolean };

export type MarkAsReadNotificationMutationVariables = Exact<{
  markAsReadNotificationArgs: MarkAsReadNotificationArgs;
}>;


export type MarkAsReadNotificationMutation = { __typename?: 'Mutation', markAsReadNotification: boolean };

export type GetQuicklinksQueryVariables = Exact<{
  getQuicklinksArgs: GetQuicklinksArgs;
}>;


export type GetQuicklinksQuery = { __typename?: 'Query', getQuicklinks: Array<{ __typename?: 'QuickLink', id: number, title: string, url: string, description?: string | null | undefined, createdById: number, createdBy: string, updatedById: number, updatedBy: string, createdAt: any, updatedAt: any }> };

export type GetQuicklinkByIdQueryVariables = Exact<{
  getQuicklinkByIdArgs: GetQuicklinkByIdArgs;
}>;


export type GetQuicklinkByIdQuery = { __typename?: 'Query', getQuicklinkById: { __typename?: 'QuickLink', id: number, title: string, url: string, description?: string | null | undefined, createdById: number, createdBy: string, updatedById: number, updatedBy: string, createdAt: any, updatedAt: any } };

export type UpdateQuickLinkByIdMutationVariables = Exact<{
  updateQuicklinkByIdArgs: UpdateQuicklinkByIdArgs;
}>;


export type UpdateQuickLinkByIdMutation = { __typename?: 'Mutation', updateQuickLinkById: boolean };

export type AddQuickLinkMutationVariables = Exact<{
  addQuicklinkArgs: AddQuicklinkArgs;
}>;


export type AddQuickLinkMutation = { __typename?: 'Mutation', addQuickLink: boolean };

export type DeleteQuickLinkByIdMutationVariables = Exact<{
  deleteQuicklinkByIdArgs: DeleteQuicklinkByIdArgs;
}>;


export type DeleteQuickLinkByIdMutation = { __typename?: 'Mutation', deleteQuickLinkById: boolean };

export type GetReferralForVerificationQueryVariables = Exact<{
  getReferralForVerificationArgs: GetReferralForVerificationArgs;
}>;


export type GetReferralForVerificationQuery = { __typename?: 'Query', getReferralForVerification?: { __typename?: 'ReferralVerificationInfo', requestType: string, aspect?: ReferralAspect | null | undefined, confirmStatus: string, contactEmail?: string | null | undefined, contactPhone?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, titleRole?: string | null | undefined, center?: { __typename?: 'Center', name: string, altName?: string | null | undefined, streetAddress: string, city: string, state: string, zipCode?: string | null | undefined, county?: string | null | undefined, mailingAddress?: string | null | undefined, phoneNumber: string, faxNumber?: string | null | undefined, emailAddress: string, websiteAddress: string, websiteNotes?: string | null | undefined, description?: string | null | undefined, eligibility?: string | null | undefined, feeScale?: string | null | undefined, applicationProcedure?: string | null | undefined, services: Array<{ __typename?: 'Service', name: string }> } | null | undefined } | null | undefined };

export type RespondToReferralVerificationMutationVariables = Exact<{
  respondToReferralVerificationArgs: RespondToReferralVerificationArgs;
}>;


export type RespondToReferralVerificationMutation = { __typename?: 'Mutation', respondToReferralVerification: { __typename?: 'ReferralVerificationResponse', success: boolean, alreadyResponded: boolean } };

export type RespondToReferralUpdateMutationVariables = Exact<{
  respondToReferralUpdateArgs: RespondToReferralUpdateArgs;
}>;


export type RespondToReferralUpdateMutation = { __typename?: 'Mutation', respondToReferralUpdate: { __typename?: 'ReferralVerificationResponse', success: boolean, alreadyResponded: boolean } };

export type GetAllUsersQueryVariables = Exact<{
  getAllUsersArgs: GetAllUsersArgs;
}>;


export type GetAllUsersQuery = { __typename?: 'Query', getAllUsers: Array<{ __typename?: 'User', id: number, clientId: number, clientName: string, firstName?: string | null | undefined, lastName?: string | null | undefined, email: string, privileges: Array<Privileges>, role: Roles }> };

export type GetAllUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUserRolesQuery = { __typename?: 'Query', getAllUserRoles: Array<Roles> };

export type GetUserByIdQueryVariables = Exact<{
  getUserByIdArgs: GetUserByIdArgs;
}>;


export type GetUserByIdQuery = { __typename?: 'Query', getUserById: { __typename?: 'User', id: number, clientId: number, clientName: string, firstName?: string | null | undefined, lastName?: string | null | undefined, email: string, privileges: Array<Privileges>, role: Roles } };

export type ForgotPasswordMutationVariables = Exact<{
  forgotPasswordArgs: ForgotPasswordArgs;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type AddUserMutationVariables = Exact<{
  addUserArgs: AddUserArgs;
}>;


export type AddUserMutation = { __typename?: 'Mutation', addUser: boolean };

export type EditUserMutationVariables = Exact<{
  editUserArgs: EditUserArgs;
}>;


export type EditUserMutation = { __typename?: 'Mutation', editUser: boolean };

export type UpdateUserRoleMutationVariables = Exact<{
  updateUserRoleArgs: UpdateUserRoleArgs;
}>;


export type UpdateUserRoleMutation = { __typename?: 'Mutation', updateUserRole: boolean };


export const GetPatientsByClientIdDocument = gql`
    query getPatientsByClientId($getPatientsByClientIdArgs: GetPatientsByClientIdArgs!) {
  getPatientsByClientId(getPatientsByClientIdArgs: $getPatientsByClientIdArgs) {
    id
    assignedUserId
    firstName
    lastName
    email
    phone
    ipAddress
    clientId
    caseNum
    middleName
    notes
  }
}
    `;

/**
 * __useGetPatientsByClientIdQuery__
 *
 * To run a query within a React component, call `useGetPatientsByClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientsByClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientsByClientIdQuery({
 *   variables: {
 *      getPatientsByClientIdArgs: // value for 'getPatientsByClientIdArgs'
 *   },
 * });
 */
export function useGetPatientsByClientIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPatientsByClientIdQuery, GetPatientsByClientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPatientsByClientIdQuery, GetPatientsByClientIdQueryVariables>(GetPatientsByClientIdDocument, options);
      }
export function useGetPatientsByClientIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPatientsByClientIdQuery, GetPatientsByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPatientsByClientIdQuery, GetPatientsByClientIdQueryVariables>(GetPatientsByClientIdDocument, options);
        }
export type GetPatientsByClientIdQueryHookResult = ReturnType<typeof useGetPatientsByClientIdQuery>;
export type GetPatientsByClientIdLazyQueryHookResult = ReturnType<typeof useGetPatientsByClientIdLazyQuery>;
export type GetPatientsByClientIdQueryResult = ApolloReactCommon.QueryResult<GetPatientsByClientIdQuery, GetPatientsByClientIdQueryVariables>;
export const GetAllClientsDocument = gql`
    query getAllClients {
  getAllClients {
    id
    name
    companyName
  }
}
    `;

/**
 * __useGetAllClientsQuery__
 *
 * To run a query within a React component, call `useGetAllClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllClientsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllClientsQuery, GetAllClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllClientsQuery, GetAllClientsQueryVariables>(GetAllClientsDocument, options);
      }
export function useGetAllClientsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllClientsQuery, GetAllClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllClientsQuery, GetAllClientsQueryVariables>(GetAllClientsDocument, options);
        }
export type GetAllClientsQueryHookResult = ReturnType<typeof useGetAllClientsQuery>;
export type GetAllClientsLazyQueryHookResult = ReturnType<typeof useGetAllClientsLazyQuery>;
export type GetAllClientsQueryResult = ApolloReactCommon.QueryResult<GetAllClientsQuery, GetAllClientsQueryVariables>;
export const GetClientDetailsDocument = gql`
    query getClientDetails($getClientDetailsArgs: GetClientDetailsArgs!) {
  getClientDetails(getClientDetailsArgs: $getClientDetailsArgs) {
    id
    name
    contactEmail
    number
    contactPerson
  }
}
    `;

/**
 * __useGetClientDetailsQuery__
 *
 * To run a query within a React component, call `useGetClientDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientDetailsQuery({
 *   variables: {
 *      getClientDetailsArgs: // value for 'getClientDetailsArgs'
 *   },
 * });
 */
export function useGetClientDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClientDetailsQuery, GetClientDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClientDetailsQuery, GetClientDetailsQueryVariables>(GetClientDetailsDocument, options);
      }
export function useGetClientDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientDetailsQuery, GetClientDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClientDetailsQuery, GetClientDetailsQueryVariables>(GetClientDetailsDocument, options);
        }
export type GetClientDetailsQueryHookResult = ReturnType<typeof useGetClientDetailsQuery>;
export type GetClientDetailsLazyQueryHookResult = ReturnType<typeof useGetClientDetailsLazyQuery>;
export type GetClientDetailsQueryResult = ApolloReactCommon.QueryResult<GetClientDetailsQuery, GetClientDetailsQueryVariables>;
export const AddClientDocument = gql`
    mutation addClient($addClientArgs: AddClientArgs!) {
  addClient(addClientArgs: $addClientArgs)
}
    `;
export type AddClientMutationFn = ApolloReactCommon.MutationFunction<AddClientMutation, AddClientMutationVariables>;

/**
 * __useAddClientMutation__
 *
 * To run a mutation, you first call `useAddClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClientMutation, { data, loading, error }] = useAddClientMutation({
 *   variables: {
 *      addClientArgs: // value for 'addClientArgs'
 *   },
 * });
 */
export function useAddClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddClientMutation, AddClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddClientMutation, AddClientMutationVariables>(AddClientDocument, options);
      }
export type AddClientMutationHookResult = ReturnType<typeof useAddClientMutation>;
export type AddClientMutationResult = ApolloReactCommon.MutationResult<AddClientMutation>;
export type AddClientMutationOptions = ApolloReactCommon.BaseMutationOptions<AddClientMutation, AddClientMutationVariables>;
export const UpdateClientDetailsDocument = gql`
    mutation updateClientDetails($updateClientDetailsArgs: UpdateClientDetailsArgs!) {
  updateClientDetails(updateClientDetailsArgs: $updateClientDetailsArgs)
}
    `;
export type UpdateClientDetailsMutationFn = ApolloReactCommon.MutationFunction<UpdateClientDetailsMutation, UpdateClientDetailsMutationVariables>;

/**
 * __useUpdateClientDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateClientDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientDetailsMutation, { data, loading, error }] = useUpdateClientDetailsMutation({
 *   variables: {
 *      updateClientDetailsArgs: // value for 'updateClientDetailsArgs'
 *   },
 * });
 */
export function useUpdateClientDetailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateClientDetailsMutation, UpdateClientDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateClientDetailsMutation, UpdateClientDetailsMutationVariables>(UpdateClientDetailsDocument, options);
      }
export type UpdateClientDetailsMutationHookResult = ReturnType<typeof useUpdateClientDetailsMutation>;
export type UpdateClientDetailsMutationResult = ApolloReactCommon.MutationResult<UpdateClientDetailsMutation>;
export type UpdateClientDetailsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateClientDetailsMutation, UpdateClientDetailsMutationVariables>;
export const DeleteClientDocument = gql`
    mutation deleteClient($deleteClientArgs: DeleteClientArgs!) {
  deleteClient(deleteClientArgs: $deleteClientArgs)
}
    `;
export type DeleteClientMutationFn = ApolloReactCommon.MutationFunction<DeleteClientMutation, DeleteClientMutationVariables>;

/**
 * __useDeleteClientMutation__
 *
 * To run a mutation, you first call `useDeleteClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientMutation, { data, loading, error }] = useDeleteClientMutation({
 *   variables: {
 *      deleteClientArgs: // value for 'deleteClientArgs'
 *   },
 * });
 */
export function useDeleteClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteClientMutation, DeleteClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteClientMutation, DeleteClientMutationVariables>(DeleteClientDocument, options);
      }
export type DeleteClientMutationHookResult = ReturnType<typeof useDeleteClientMutation>;
export type DeleteClientMutationResult = ApolloReactCommon.MutationResult<DeleteClientMutation>;
export type DeleteClientMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteClientMutation, DeleteClientMutationVariables>;
export const GetClientRolePrivilegesDocument = gql`
    query getClientRolePrivileges($getClientRolePrivilegesArgs: GetClientRolePrivilegesArgs!) {
  getClientRolePrivileges(
    getClientRolePrivilegesArgs: $getClientRolePrivilegesArgs
  ) {
    feature
    category
    accesses
  }
}
    `;

/**
 * __useGetClientRolePrivilegesQuery__
 *
 * To run a query within a React component, call `useGetClientRolePrivilegesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientRolePrivilegesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientRolePrivilegesQuery({
 *   variables: {
 *      getClientRolePrivilegesArgs: // value for 'getClientRolePrivilegesArgs'
 *   },
 * });
 */
export function useGetClientRolePrivilegesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClientRolePrivilegesQuery, GetClientRolePrivilegesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClientRolePrivilegesQuery, GetClientRolePrivilegesQueryVariables>(GetClientRolePrivilegesDocument, options);
      }
export function useGetClientRolePrivilegesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientRolePrivilegesQuery, GetClientRolePrivilegesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClientRolePrivilegesQuery, GetClientRolePrivilegesQueryVariables>(GetClientRolePrivilegesDocument, options);
        }
export type GetClientRolePrivilegesQueryHookResult = ReturnType<typeof useGetClientRolePrivilegesQuery>;
export type GetClientRolePrivilegesLazyQueryHookResult = ReturnType<typeof useGetClientRolePrivilegesLazyQuery>;
export type GetClientRolePrivilegesQueryResult = ApolloReactCommon.QueryResult<GetClientRolePrivilegesQuery, GetClientRolePrivilegesQueryVariables>;
export const GetCurrentUserClientRolesDocument = gql`
    query getCurrentUserClientRoles($getCurrentUserClientRolesArgs: GetCurrentUserClientRolesArgs!) {
  getCurrentUserClientRoles(
    getCurrentUserClientRolesArgs: $getCurrentUserClientRolesArgs
  ) {
    feature
    category
    accesses
    keyword
    isDefault
    keywordId
    keywordClass
  }
}
    `;

/**
 * __useGetCurrentUserClientRolesQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserClientRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserClientRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserClientRolesQuery({
 *   variables: {
 *      getCurrentUserClientRolesArgs: // value for 'getCurrentUserClientRolesArgs'
 *   },
 * });
 */
export function useGetCurrentUserClientRolesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCurrentUserClientRolesQuery, GetCurrentUserClientRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCurrentUserClientRolesQuery, GetCurrentUserClientRolesQueryVariables>(GetCurrentUserClientRolesDocument, options);
      }
export function useGetCurrentUserClientRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurrentUserClientRolesQuery, GetCurrentUserClientRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCurrentUserClientRolesQuery, GetCurrentUserClientRolesQueryVariables>(GetCurrentUserClientRolesDocument, options);
        }
export type GetCurrentUserClientRolesQueryHookResult = ReturnType<typeof useGetCurrentUserClientRolesQuery>;
export type GetCurrentUserClientRolesLazyQueryHookResult = ReturnType<typeof useGetCurrentUserClientRolesLazyQuery>;
export type GetCurrentUserClientRolesQueryResult = ApolloReactCommon.QueryResult<GetCurrentUserClientRolesQuery, GetCurrentUserClientRolesQueryVariables>;
export const AuthenticateUserDocument = gql`
    mutation authenticateUser($authenticateUserArgs: AuthenticateUserArgs!) {
  authenticateUser(authenticateUserArgs: $authenticateUserArgs)
}
    `;
export type AuthenticateUserMutationFn = ApolloReactCommon.MutationFunction<AuthenticateUserMutation, AuthenticateUserMutationVariables>;

/**
 * __useAuthenticateUserMutation__
 *
 * To run a mutation, you first call `useAuthenticateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateUserMutation, { data, loading, error }] = useAuthenticateUserMutation({
 *   variables: {
 *      authenticateUserArgs: // value for 'authenticateUserArgs'
 *   },
 * });
 */
export function useAuthenticateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticateUserMutation, AuthenticateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticateUserMutation, AuthenticateUserMutationVariables>(AuthenticateUserDocument, options);
      }
export type AuthenticateUserMutationHookResult = ReturnType<typeof useAuthenticateUserMutation>;
export type AuthenticateUserMutationResult = ApolloReactCommon.MutationResult<AuthenticateUserMutation>;
export type AuthenticateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<AuthenticateUserMutation, AuthenticateUserMutationVariables>;
export const VerifyUserOtpDocument = gql`
    mutation verifyUserOtp($verifyUserOtpArgs: VerifyUserOtpArgs!) {
  verifyUserOtp(verifyUserOtpArgs: $verifyUserOtpArgs)
}
    `;
export type VerifyUserOtpMutationFn = ApolloReactCommon.MutationFunction<VerifyUserOtpMutation, VerifyUserOtpMutationVariables>;

/**
 * __useVerifyUserOtpMutation__
 *
 * To run a mutation, you first call `useVerifyUserOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUserOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUserOtpMutation, { data, loading, error }] = useVerifyUserOtpMutation({
 *   variables: {
 *      verifyUserOtpArgs: // value for 'verifyUserOtpArgs'
 *   },
 * });
 */
export function useVerifyUserOtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyUserOtpMutation, VerifyUserOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VerifyUserOtpMutation, VerifyUserOtpMutationVariables>(VerifyUserOtpDocument, options);
      }
export type VerifyUserOtpMutationHookResult = ReturnType<typeof useVerifyUserOtpMutation>;
export type VerifyUserOtpMutationResult = ApolloReactCommon.MutationResult<VerifyUserOtpMutation>;
export type VerifyUserOtpMutationOptions = ApolloReactCommon.BaseMutationOptions<VerifyUserOtpMutation, VerifyUserOtpMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($resetPasswordArgs: ResetPasswordArgs!) {
  resetPassword(resetPasswordArgs: $resetPasswordArgs)
}
    `;
export type ResetPasswordMutationFn = ApolloReactCommon.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      resetPasswordArgs: // value for 'resetPasswordArgs'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = ApolloReactCommon.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation refreshToken($refreshTokenArgs: RefreshTokenArgs!) {
  refreshToken(refreshTokenArgs: $refreshTokenArgs)
}
    `;
export type RefreshTokenMutationFn = ApolloReactCommon.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      refreshTokenArgs: // value for 'refreshTokenArgs'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = ApolloReactCommon.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const DeleteTokenDocument = gql`
    mutation deleteToken($deleteTokenArgs: DeleteTokenArgs!) {
  deleteToken(deleteTokenArgs: $deleteTokenArgs)
}
    `;
export type DeleteTokenMutationFn = ApolloReactCommon.MutationFunction<DeleteTokenMutation, DeleteTokenMutationVariables>;

/**
 * __useDeleteTokenMutation__
 *
 * To run a mutation, you first call `useDeleteTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTokenMutation, { data, loading, error }] = useDeleteTokenMutation({
 *   variables: {
 *      deleteTokenArgs: // value for 'deleteTokenArgs'
 *   },
 * });
 */
export function useDeleteTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTokenMutation, DeleteTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTokenMutation, DeleteTokenMutationVariables>(DeleteTokenDocument, options);
      }
export type DeleteTokenMutationHookResult = ReturnType<typeof useDeleteTokenMutation>;
export type DeleteTokenMutationResult = ApolloReactCommon.MutationResult<DeleteTokenMutation>;
export type DeleteTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTokenMutation, DeleteTokenMutationVariables>;
export const GetNotificationsByIdDocument = gql`
    query getNotificationsById($getNotificationsByIdArgs: GetNotificationsByIdArgs!) {
  getNotificationsById(getNotificationsByIdArgs: $getNotificationsByIdArgs) {
    title
    message
    read
    url
    createdAt
    variant
  }
}
    `;

/**
 * __useGetNotificationsByIdQuery__
 *
 * To run a query within a React component, call `useGetNotificationsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsByIdQuery({
 *   variables: {
 *      getNotificationsByIdArgs: // value for 'getNotificationsByIdArgs'
 *   },
 * });
 */
export function useGetNotificationsByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNotificationsByIdQuery, GetNotificationsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNotificationsByIdQuery, GetNotificationsByIdQueryVariables>(GetNotificationsByIdDocument, options);
      }
export function useGetNotificationsByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationsByIdQuery, GetNotificationsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNotificationsByIdQuery, GetNotificationsByIdQueryVariables>(GetNotificationsByIdDocument, options);
        }
export type GetNotificationsByIdQueryHookResult = ReturnType<typeof useGetNotificationsByIdQuery>;
export type GetNotificationsByIdLazyQueryHookResult = ReturnType<typeof useGetNotificationsByIdLazyQuery>;
export type GetNotificationsByIdQueryResult = ApolloReactCommon.QueryResult<GetNotificationsByIdQuery, GetNotificationsByIdQueryVariables>;
export const AddNotificationDocument = gql`
    mutation addNotification($notificationPayloadArgs: NotificationPayloadArgs!) {
  addNotification(notificationPayloadArgs: $notificationPayloadArgs)
}
    `;
export type AddNotificationMutationFn = ApolloReactCommon.MutationFunction<AddNotificationMutation, AddNotificationMutationVariables>;

/**
 * __useAddNotificationMutation__
 *
 * To run a mutation, you first call `useAddNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNotificationMutation, { data, loading, error }] = useAddNotificationMutation({
 *   variables: {
 *      notificationPayloadArgs: // value for 'notificationPayloadArgs'
 *   },
 * });
 */
export function useAddNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddNotificationMutation, AddNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddNotificationMutation, AddNotificationMutationVariables>(AddNotificationDocument, options);
      }
export type AddNotificationMutationHookResult = ReturnType<typeof useAddNotificationMutation>;
export type AddNotificationMutationResult = ApolloReactCommon.MutationResult<AddNotificationMutation>;
export type AddNotificationMutationOptions = ApolloReactCommon.BaseMutationOptions<AddNotificationMutation, AddNotificationMutationVariables>;
export const MarkAsReadNotificationDocument = gql`
    mutation markAsReadNotification($markAsReadNotificationArgs: MarkAsReadNotificationArgs!) {
  markAsReadNotification(markAsReadNotificationArgs: $markAsReadNotificationArgs)
}
    `;
export type MarkAsReadNotificationMutationFn = ApolloReactCommon.MutationFunction<MarkAsReadNotificationMutation, MarkAsReadNotificationMutationVariables>;

/**
 * __useMarkAsReadNotificationMutation__
 *
 * To run a mutation, you first call `useMarkAsReadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsReadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsReadNotificationMutation, { data, loading, error }] = useMarkAsReadNotificationMutation({
 *   variables: {
 *      markAsReadNotificationArgs: // value for 'markAsReadNotificationArgs'
 *   },
 * });
 */
export function useMarkAsReadNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkAsReadNotificationMutation, MarkAsReadNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkAsReadNotificationMutation, MarkAsReadNotificationMutationVariables>(MarkAsReadNotificationDocument, options);
      }
export type MarkAsReadNotificationMutationHookResult = ReturnType<typeof useMarkAsReadNotificationMutation>;
export type MarkAsReadNotificationMutationResult = ApolloReactCommon.MutationResult<MarkAsReadNotificationMutation>;
export type MarkAsReadNotificationMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkAsReadNotificationMutation, MarkAsReadNotificationMutationVariables>;
export const GetQuicklinksDocument = gql`
    query getQuicklinks($getQuicklinksArgs: GetQuicklinksArgs!) {
  getQuicklinks(getQuicklinks: $getQuicklinksArgs) {
    id
    title
    url
    description
    createdById
    createdBy
    updatedById
    updatedBy
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetQuicklinksQuery__
 *
 * To run a query within a React component, call `useGetQuicklinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuicklinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuicklinksQuery({
 *   variables: {
 *      getQuicklinksArgs: // value for 'getQuicklinksArgs'
 *   },
 * });
 */
export function useGetQuicklinksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetQuicklinksQuery, GetQuicklinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetQuicklinksQuery, GetQuicklinksQueryVariables>(GetQuicklinksDocument, options);
      }
export function useGetQuicklinksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuicklinksQuery, GetQuicklinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetQuicklinksQuery, GetQuicklinksQueryVariables>(GetQuicklinksDocument, options);
        }
export type GetQuicklinksQueryHookResult = ReturnType<typeof useGetQuicklinksQuery>;
export type GetQuicklinksLazyQueryHookResult = ReturnType<typeof useGetQuicklinksLazyQuery>;
export type GetQuicklinksQueryResult = ApolloReactCommon.QueryResult<GetQuicklinksQuery, GetQuicklinksQueryVariables>;
export const GetQuicklinkByIdDocument = gql`
    query getQuicklinkById($getQuicklinkByIdArgs: GetQuicklinkByIdArgs!) {
  getQuicklinkById(getQuicklinkById: $getQuicklinkByIdArgs) {
    id
    title
    url
    description
    createdById
    createdBy
    updatedById
    updatedBy
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetQuicklinkByIdQuery__
 *
 * To run a query within a React component, call `useGetQuicklinkByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuicklinkByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuicklinkByIdQuery({
 *   variables: {
 *      getQuicklinkByIdArgs: // value for 'getQuicklinkByIdArgs'
 *   },
 * });
 */
export function useGetQuicklinkByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetQuicklinkByIdQuery, GetQuicklinkByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetQuicklinkByIdQuery, GetQuicklinkByIdQueryVariables>(GetQuicklinkByIdDocument, options);
      }
export function useGetQuicklinkByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuicklinkByIdQuery, GetQuicklinkByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetQuicklinkByIdQuery, GetQuicklinkByIdQueryVariables>(GetQuicklinkByIdDocument, options);
        }
export type GetQuicklinkByIdQueryHookResult = ReturnType<typeof useGetQuicklinkByIdQuery>;
export type GetQuicklinkByIdLazyQueryHookResult = ReturnType<typeof useGetQuicklinkByIdLazyQuery>;
export type GetQuicklinkByIdQueryResult = ApolloReactCommon.QueryResult<GetQuicklinkByIdQuery, GetQuicklinkByIdQueryVariables>;
export const UpdateQuickLinkByIdDocument = gql`
    mutation updateQuickLinkById($updateQuicklinkByIdArgs: UpdateQuicklinkByIdArgs!) {
  updateQuickLinkById(updateQuickLinkById: $updateQuicklinkByIdArgs)
}
    `;
export type UpdateQuickLinkByIdMutationFn = ApolloReactCommon.MutationFunction<UpdateQuickLinkByIdMutation, UpdateQuickLinkByIdMutationVariables>;

/**
 * __useUpdateQuickLinkByIdMutation__
 *
 * To run a mutation, you first call `useUpdateQuickLinkByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuickLinkByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuickLinkByIdMutation, { data, loading, error }] = useUpdateQuickLinkByIdMutation({
 *   variables: {
 *      updateQuicklinkByIdArgs: // value for 'updateQuicklinkByIdArgs'
 *   },
 * });
 */
export function useUpdateQuickLinkByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateQuickLinkByIdMutation, UpdateQuickLinkByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateQuickLinkByIdMutation, UpdateQuickLinkByIdMutationVariables>(UpdateQuickLinkByIdDocument, options);
      }
export type UpdateQuickLinkByIdMutationHookResult = ReturnType<typeof useUpdateQuickLinkByIdMutation>;
export type UpdateQuickLinkByIdMutationResult = ApolloReactCommon.MutationResult<UpdateQuickLinkByIdMutation>;
export type UpdateQuickLinkByIdMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateQuickLinkByIdMutation, UpdateQuickLinkByIdMutationVariables>;
export const AddQuickLinkDocument = gql`
    mutation addQuickLink($addQuicklinkArgs: AddQuicklinkArgs!) {
  addQuickLink(addQuickLink: $addQuicklinkArgs)
}
    `;
export type AddQuickLinkMutationFn = ApolloReactCommon.MutationFunction<AddQuickLinkMutation, AddQuickLinkMutationVariables>;

/**
 * __useAddQuickLinkMutation__
 *
 * To run a mutation, you first call `useAddQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuickLinkMutation, { data, loading, error }] = useAddQuickLinkMutation({
 *   variables: {
 *      addQuicklinkArgs: // value for 'addQuicklinkArgs'
 *   },
 * });
 */
export function useAddQuickLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddQuickLinkMutation, AddQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddQuickLinkMutation, AddQuickLinkMutationVariables>(AddQuickLinkDocument, options);
      }
export type AddQuickLinkMutationHookResult = ReturnType<typeof useAddQuickLinkMutation>;
export type AddQuickLinkMutationResult = ApolloReactCommon.MutationResult<AddQuickLinkMutation>;
export type AddQuickLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<AddQuickLinkMutation, AddQuickLinkMutationVariables>;
export const DeleteQuickLinkByIdDocument = gql`
    mutation deleteQuickLinkById($deleteQuicklinkByIdArgs: DeleteQuicklinkByIdArgs!) {
  deleteQuickLinkById(deleteQuickLinkById: $deleteQuicklinkByIdArgs)
}
    `;
export type DeleteQuickLinkByIdMutationFn = ApolloReactCommon.MutationFunction<DeleteQuickLinkByIdMutation, DeleteQuickLinkByIdMutationVariables>;

/**
 * __useDeleteQuickLinkByIdMutation__
 *
 * To run a mutation, you first call `useDeleteQuickLinkByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuickLinkByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuickLinkByIdMutation, { data, loading, error }] = useDeleteQuickLinkByIdMutation({
 *   variables: {
 *      deleteQuicklinkByIdArgs: // value for 'deleteQuicklinkByIdArgs'
 *   },
 * });
 */
export function useDeleteQuickLinkByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteQuickLinkByIdMutation, DeleteQuickLinkByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteQuickLinkByIdMutation, DeleteQuickLinkByIdMutationVariables>(DeleteQuickLinkByIdDocument, options);
      }
export type DeleteQuickLinkByIdMutationHookResult = ReturnType<typeof useDeleteQuickLinkByIdMutation>;
export type DeleteQuickLinkByIdMutationResult = ApolloReactCommon.MutationResult<DeleteQuickLinkByIdMutation>;
export type DeleteQuickLinkByIdMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteQuickLinkByIdMutation, DeleteQuickLinkByIdMutationVariables>;
export const GetReferralForVerificationDocument = gql`
    query getReferralForVerification($getReferralForVerificationArgs: GetReferralForVerificationArgs!) {
  getReferralForVerification(
    getReferralForVerificationArgs: $getReferralForVerificationArgs
  ) {
    requestType
    aspect
    confirmStatus
    contactEmail
    contactPhone
    firstName
    lastName
    titleRole
    center {
      name
      altName
      streetAddress
      city
      state
      zipCode
      county
      mailingAddress
      phoneNumber
      faxNumber
      emailAddress
      websiteAddress
      websiteNotes
      description
      eligibility
      feeScale
      applicationProcedure
      services {
        name
      }
    }
  }
}
    `;

/**
 * __useGetReferralForVerificationQuery__
 *
 * To run a query within a React component, call `useGetReferralForVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferralForVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferralForVerificationQuery({
 *   variables: {
 *      getReferralForVerificationArgs: // value for 'getReferralForVerificationArgs'
 *   },
 * });
 */
export function useGetReferralForVerificationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetReferralForVerificationQuery, GetReferralForVerificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReferralForVerificationQuery, GetReferralForVerificationQueryVariables>(GetReferralForVerificationDocument, options);
      }
export function useGetReferralForVerificationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReferralForVerificationQuery, GetReferralForVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReferralForVerificationQuery, GetReferralForVerificationQueryVariables>(GetReferralForVerificationDocument, options);
        }
export type GetReferralForVerificationQueryHookResult = ReturnType<typeof useGetReferralForVerificationQuery>;
export type GetReferralForVerificationLazyQueryHookResult = ReturnType<typeof useGetReferralForVerificationLazyQuery>;
export type GetReferralForVerificationQueryResult = ApolloReactCommon.QueryResult<GetReferralForVerificationQuery, GetReferralForVerificationQueryVariables>;
export const RespondToReferralVerificationDocument = gql`
    mutation respondToReferralVerification($respondToReferralVerificationArgs: RespondToReferralVerificationArgs!) {
  respondToReferralVerification(
    respondToReferralVerificationArgs: $respondToReferralVerificationArgs
  ) {
    success
    alreadyResponded
  }
}
    `;
export type RespondToReferralVerificationMutationFn = ApolloReactCommon.MutationFunction<RespondToReferralVerificationMutation, RespondToReferralVerificationMutationVariables>;

/**
 * __useRespondToReferralVerificationMutation__
 *
 * To run a mutation, you first call `useRespondToReferralVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToReferralVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToReferralVerificationMutation, { data, loading, error }] = useRespondToReferralVerificationMutation({
 *   variables: {
 *      respondToReferralVerificationArgs: // value for 'respondToReferralVerificationArgs'
 *   },
 * });
 */
export function useRespondToReferralVerificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RespondToReferralVerificationMutation, RespondToReferralVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RespondToReferralVerificationMutation, RespondToReferralVerificationMutationVariables>(RespondToReferralVerificationDocument, options);
      }
export type RespondToReferralVerificationMutationHookResult = ReturnType<typeof useRespondToReferralVerificationMutation>;
export type RespondToReferralVerificationMutationResult = ApolloReactCommon.MutationResult<RespondToReferralVerificationMutation>;
export type RespondToReferralVerificationMutationOptions = ApolloReactCommon.BaseMutationOptions<RespondToReferralVerificationMutation, RespondToReferralVerificationMutationVariables>;
export const RespondToReferralUpdateDocument = gql`
    mutation respondToReferralUpdate($respondToReferralUpdateArgs: RespondToReferralUpdateArgs!) {
  respondToReferralUpdate(
    respondToReferralUpdateArgs: $respondToReferralUpdateArgs
  ) {
    success
    alreadyResponded
  }
}
    `;
export type RespondToReferralUpdateMutationFn = ApolloReactCommon.MutationFunction<RespondToReferralUpdateMutation, RespondToReferralUpdateMutationVariables>;

/**
 * __useRespondToReferralUpdateMutation__
 *
 * To run a mutation, you first call `useRespondToReferralUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToReferralUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToReferralUpdateMutation, { data, loading, error }] = useRespondToReferralUpdateMutation({
 *   variables: {
 *      respondToReferralUpdateArgs: // value for 'respondToReferralUpdateArgs'
 *   },
 * });
 */
export function useRespondToReferralUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RespondToReferralUpdateMutation, RespondToReferralUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RespondToReferralUpdateMutation, RespondToReferralUpdateMutationVariables>(RespondToReferralUpdateDocument, options);
      }
export type RespondToReferralUpdateMutationHookResult = ReturnType<typeof useRespondToReferralUpdateMutation>;
export type RespondToReferralUpdateMutationResult = ApolloReactCommon.MutationResult<RespondToReferralUpdateMutation>;
export type RespondToReferralUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<RespondToReferralUpdateMutation, RespondToReferralUpdateMutationVariables>;
export const GetAllUsersDocument = gql`
    query getAllUsers($getAllUsersArgs: GetAllUsersArgs!) {
  getAllUsers(getAllUsersArgs: $getAllUsersArgs) {
    id
    clientId
    clientName
    firstName
    lastName
    email
    privileges
    role
  }
}
    `;

/**
 * __useGetAllUsersQuery__
 *
 * To run a query within a React component, call `useGetAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUsersQuery({
 *   variables: {
 *      getAllUsersArgs: // value for 'getAllUsersArgs'
 *   },
 * });
 */
export function useGetAllUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
      }
export function useGetAllUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
export type GetAllUsersQueryHookResult = ReturnType<typeof useGetAllUsersQuery>;
export type GetAllUsersLazyQueryHookResult = ReturnType<typeof useGetAllUsersLazyQuery>;
export type GetAllUsersQueryResult = ApolloReactCommon.QueryResult<GetAllUsersQuery, GetAllUsersQueryVariables>;
export const GetAllUserRolesDocument = gql`
    query getAllUserRoles {
  getAllUserRoles
}
    `;

/**
 * __useGetAllUserRolesQuery__
 *
 * To run a query within a React component, call `useGetAllUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUserRolesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllUserRolesQuery, GetAllUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllUserRolesQuery, GetAllUserRolesQueryVariables>(GetAllUserRolesDocument, options);
      }
export function useGetAllUserRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllUserRolesQuery, GetAllUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllUserRolesQuery, GetAllUserRolesQueryVariables>(GetAllUserRolesDocument, options);
        }
export type GetAllUserRolesQueryHookResult = ReturnType<typeof useGetAllUserRolesQuery>;
export type GetAllUserRolesLazyQueryHookResult = ReturnType<typeof useGetAllUserRolesLazyQuery>;
export type GetAllUserRolesQueryResult = ApolloReactCommon.QueryResult<GetAllUserRolesQuery, GetAllUserRolesQueryVariables>;
export const GetUserByIdDocument = gql`
    query getUserById($getUserByIdArgs: GetUserByIdArgs!) {
  getUserById(getUserByIdArgs: $getUserByIdArgs) {
    id
    clientId
    clientName
    firstName
    lastName
    email
    privileges
    role
  }
}
    `;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      getUserByIdArgs: // value for 'getUserByIdArgs'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdQueryResult = ApolloReactCommon.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($forgotPasswordArgs: ForgotPasswordArgs!) {
  forgotPassword(forgotPasswordArgs: $forgotPasswordArgs)
}
    `;
export type ForgotPasswordMutationFn = ApolloReactCommon.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      forgotPasswordArgs: // value for 'forgotPasswordArgs'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = ApolloReactCommon.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const AddUserDocument = gql`
    mutation addUser($addUserArgs: AddUserArgs!) {
  addUser(addUserArgs: $addUserArgs)
}
    `;
export type AddUserMutationFn = ApolloReactCommon.MutationFunction<AddUserMutation, AddUserMutationVariables>;

/**
 * __useAddUserMutation__
 *
 * To run a mutation, you first call `useAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserMutation, { data, loading, error }] = useAddUserMutation({
 *   variables: {
 *      addUserArgs: // value for 'addUserArgs'
 *   },
 * });
 */
export function useAddUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddUserMutation, AddUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddUserMutation, AddUserMutationVariables>(AddUserDocument, options);
      }
export type AddUserMutationHookResult = ReturnType<typeof useAddUserMutation>;
export type AddUserMutationResult = ApolloReactCommon.MutationResult<AddUserMutation>;
export type AddUserMutationOptions = ApolloReactCommon.BaseMutationOptions<AddUserMutation, AddUserMutationVariables>;
export const EditUserDocument = gql`
    mutation editUser($editUserArgs: EditUserArgs!) {
  editUser(editUserArgs: $editUserArgs)
}
    `;
export type EditUserMutationFn = ApolloReactCommon.MutationFunction<EditUserMutation, EditUserMutationVariables>;

/**
 * __useEditUserMutation__
 *
 * To run a mutation, you first call `useEditUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserMutation, { data, loading, error }] = useEditUserMutation({
 *   variables: {
 *      editUserArgs: // value for 'editUserArgs'
 *   },
 * });
 */
export function useEditUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditUserMutation, EditUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditUserMutation, EditUserMutationVariables>(EditUserDocument, options);
      }
export type EditUserMutationHookResult = ReturnType<typeof useEditUserMutation>;
export type EditUserMutationResult = ApolloReactCommon.MutationResult<EditUserMutation>;
export type EditUserMutationOptions = ApolloReactCommon.BaseMutationOptions<EditUserMutation, EditUserMutationVariables>;
export const UpdateUserRoleDocument = gql`
    mutation updateUserRole($updateUserRoleArgs: UpdateUserRoleArgs!) {
  updateUserRole(updateUserRoleArgs: $updateUserRoleArgs)
}
    `;
export type UpdateUserRoleMutationFn = ApolloReactCommon.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      updateUserRoleArgs: // value for 'updateUserRoleArgs'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>(UpdateUserRoleDocument, options);
      }
export type UpdateUserRoleMutationHookResult = ReturnType<typeof useUpdateUserRoleMutation>;
export type UpdateUserRoleMutationResult = ApolloReactCommon.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;